/* eslint-disable quotes, max-len */
export default {
    a_list_is_required: "une liste est requise",
    accept_and_schedule: "Accepter et programmer",
    accepted_files_types: "Types de fichiers acceptés:",
    account_deactivated: "Ce compte a été désactivé.",
    accumulated_points: "Points Accumulés",
    accumulated_points_calculates_the_total_point_value: "Les points cumulés calculent la valeur totale des points possible pour l'enquête",
    acknowledge: "Accuser réception",
    acknowledgment_required: "Accusé de Réception Requis",
    actions: "Actions",
    activate: "Activer",
    activate_client_body: "Vous pouvez à tout moment désactiver à nouveau ce client.",
    activate_client_title: "Vous êtes sur le point d'activer ce client",
    activate_project: "Activer le projet",
    active: "Actif",
    active_project_editing_alert: "Toute modification de ces détails pourrait avoir des répercussions sur les projets actifs.",
    active_tags: "Etiquette (s) active (s)",
    activity: "Activité",
    activity_details: "Détails de l'activité",
    activity_log: "Journal d'activité",
    activity_name: "Nom de l'activité",
    activity_number: "Numéro d'activité",
    activity_overview: "Aperçu de l'activité",
    activity_status: "Statut d'activité",
    actual_time: "Heure réelle",
    add: "Ajouter",
    add_a_filter: "Ajouter un Filtre",
    add_a_job: "Ajouter un travail",
    add_a_link: "Ajouter un lien",
    add_a_question: "Ajouter une question",
    add_a_tag: "Ajouter une balise",
    add_assignment_to_project: "Ajouter des affectations au projet",
    add_client: "Ajouter un client",
    add_display_logic: "Ajouter une logique d'affichage",
    add_instructions_here: "Ajouter des instructions ici",
    add_item_requests: "Ajouter des demandes d'articles",
    add_item_set_to_question: "Ajouter un ensemble d'articles à la question",
    add_items: "Ajouter des articles",
    add_items_to_item_set: "Ajouter des éléments à l'ensemble d'éléments",
    add_links: "Ajouter des liens",
    add_location: "Ajouter un emplacement",
    add_locations: "Ajouter des emplacements",
    add_note: "Ajouter une note",
    add_opportunities: "Ajouter des opportunités",
    add_or_remove_items: "Ajouter ou supprimer des éléments",
    add_rep: "Ajouter Un Représentant",
    add_reps: "Ajouter des Représentants",
    add_roles: "Ajouter des rôles",
    add_survey_text: "bouton pour joindre des questions à ce travail.",
    add_tag: "Ajouter une balise",
    add_tags: "Ajouter des balises",
    add_to_max_custom_fields: "Maximum de 30 zones personnalisées.",
    add_to_selections: "Ajouter aux sélections",
    add_values: "Ajouter des valeurs",
    added: "Ajoutée",
    additional_email_recipients: "Destinataires d'e-mails supplémentaires",
    additional_info: "Info(s) suplémentaire(s)",
    additional_work: "Travail supplémentaire",
    address: "Adresse",
    address2: "Adresse supplémentaire",
    address_2: "Adresse supplémentaire",
    address_details_title: "Détails de l'adresse",
    addresses: "Adresses",
    adjust_filter_preamble: " | Ajuster ou",
    adjust_filters: "Veuillez ajuster le jeu de filtres pour remplir les données ou",
    adjust_person_and_project_filters: "Ajustez vos filtres d'identifiant de personne et de projet.",
    adjust_person_filters: "Ajustez vos filtres de personne.",
    adjust_project_filters: "Ajustez vos filtres d'identifiant de projet.",
    adjust_search: "Veuillez ajuster la recherche pour remplir les données ou",
    adjust_the_filter_set: "régler le jeu de filtres",
    admin_return: "Retour à AwesomeAdmin",
    admin_settings: "Paramètres d'administration",
    advanced_details_title: "Détails avancés",
    after: "Après",
    after_number_of_occurrences: "Après le nombre d'occurrences",
    after_work_is_due: "Après le travail est dû",
    ai_scheduling: "Planification IA",
    all: "Tout",
    all_day: "Toute la journée",
    all_master_questions: "Toutes les questions principales",
    all_opportunities_created: "Toutes les opportunités créées",
    all_options_must_have_text: "Toutes les options doivent contenir du texte.",
    all_partial_parameter_sub_text: "Pour créer des opportunités pour toutes les visites ouvertes, veuillez ajuster vos paramètres et vos besoins en personnel.",
    all_priorities: "Toutes les priorités",
    all_questions_must_contain_text: "Toutes les questions doivent contenir du texte.",
    all_retailer_or_custom_field_selected_message: "Nous avons rationalisé votre sélection pour utiliser « Tous les emplacements » pour une efficacité améliorée. Rassurez-vous, cet ajustement n'impactera pas vos emplacements soigneusement sélectionnés.",
    all_roles: "Tous les rôles",
    all_skills_and_capabilities: "Toutes les compétences et capacités",
    all_time_limited_to_completed: "Tout le temps limité à Terminé",
    all_times_displayed_in_location_timezone: "Toutes les heures affichées dans le fuseau horaire de l'emplacement",
    allow_barcode_scanner: "Autoriser le scanner de code-barres",
    allow_decimals: "Autoriser les décimales",
    allow_email_addresses_of_existing_reps: "Autoriser Les Adresses E-mail Du Représentant Existant",
    allow_recipients_to_refresh_report_data: "Autoriser les destinataires à actualiser les données du rapport",
    allowed_to_schedule: "Autorisé à planifier",
    alphanumeric_and_spaces_and_dashes_only: "Seuls les caractères alphanumériques, les espaces et les tirets sont autorisés.",
    already_exists_in_the_database: "existe déjà dans la base de données",
    amp_by_movista: "AMP par Movista",
    and: "et",
    announcement_title: "Titre de l'annonce",
    announcements: "Annonces",
    answers_link: "Lien vers les réponses",
    anyone_can_see_this: "Tout le monde peut voir le nom de cet événement.",
    anytime: "N'importe quand",
    anytime_after: "À tout moment après",
    anytime_before: "N'importe quand avant",
    api_error_message: "Nous ne sommes pas en mesure de répondre à votre demande pour le moment. Veuillez réessayer ultérieurement.",
    app_version: "Version de l'application",
    apply: "Appliquer",
    apply_filters: "Appliquer des Filtres",
    approval_feedback_will_be_emailed_to_the_rep: "Les commentaires d'approbation seront envoyés par e-mail au représentant",
    approve: "Approuver",
    approve_visit: "Approuver la visite",
    approved: "Approuvé",
    apr: "Avr",
    archive: "Archiver",
    archived: "Archivé",
    are_late: "Sont en retard",
    are_you_sure_you_want_to_delete_the: "Voulez-vous vraiment supprimer la?",
    are_you_sure_you_want_to_delete_the_existing_visit_details: "Voulez-vous vraiment supprimer les détails de la visite existante?",
    are_you_sure_you_want_to_delete_this: "Êtes-vous sûr de vouloir supprimer ce?",
    are_you_sure_you_want_to_delete_this_attribute: "Êtes-vous sûr de vouloir supprimer cet attribut",
    are_you_sure_you_want_to_delete_this_gallery: "Etes-vous sûr de vouloir supprimer cette galerie?",
    are_you_sure_you_want_to_delete_this_note: "Êtes-vous sûr de vouloir supprimer cette note?",
    are_you_sure_you_want_to_delete_this_report: "Êtes-vous sûr de vouloir supprimer cette rapport?",
    are_you_sure_you_want_to_remove_these_photos_from_this_gallery: "Voulez-vous vraiment supprimer ces photos de cette galerie ?",
    are_you_sure_you_want_to_unassign_this_visit_from_this_person: "Etes-vous sûr de vouloir supprimer cet événement de l'agenda? L'événement peut ensuite être ajouté au planning d'une autre personne.",
    assignable: "Affectable",
    assigned_locations: "Emplacements Attribués",
    assigned_role: "Rôle attribué",
    assigned_role_s: "Rôle(s) attribué(s)",
    assigned_roles: "Rôles attribués",
    assigned_staff: "Personnel affecté",
    assigned_staff_direct_supervisor: "Superviseur(s) direct(s) du personnel affecté",
    assigned_staff_level2_supervisor: "Superviseur(s) de niveau 2 du personnel affecté",
    assigned_staff_level3_supervisor: "Superviseur(s) de niveau 3 du personnel affecté",
    assigned_staff_top_level_supervisor: "Superviseur(s) supérieur(s) du personnel affecté",
    assigned_to: "Assigné à",
    assigner: "Cédant",
    assignment_type: "Type d'affectation",
    assignment_value: "Valeur d'affectation",
    assignment_values: "'Valeurs d'affectation'",
    assignments: "Attributions",
    assignments_visits_title: "Affectations et visites",
    at: "à",
    at_column: "à la colonne",
    at_risk: "Au risque d'être en retard",
    at_risk_short: "À risque",
    at_risk_to_be_late_status: "À risque d'être en retard",
    atrisk_default_details: "L'avancement du projet fera l'objet d'un suivi afin de déterminer s'il peut être achevé à temps. Nous calculons si une réalisation dans les délais est possible en fonction du pourcentage de projets soumis et du nombre de jours restants.",
    atrisk_manual_details: "Le projet sera signalé comme étant à risque d'être en retard en fonction de vos spécifications. Choisissez le nombre de jours avant la date d'échéance et le seuil de pourcentage de soumission que vous souhaitez que le projet atteigne, sinon il sera signalé comme étant à risque d'être en retard.",
    attach_image: "Joindre une Image",
    attached_to_a_question: "Attaché à une question",
    attribute_values: "Valeurs d'attribut",
    attributes: "Les attributs",
    attributes_title: "Les attributs",
    audited_miles: "Miles vérifiés",
    audited_miles_authorized: "Miles vérifiés autorisés",
    aug: "Août",
    auto_approve_work: "Approbation automatique du travail",
    auto_approve_work_after: "Approuver automatiquement le travail après",
    auto_approve_work_help: "Gérez quand le projet sera automatiquement approuvé. Si un intervalle de temps est sélectionné, une fois qu'une visite a été soumise et que la visite n'est pas approuvée dans le délai sélectionné, elle sera automatiquement approuvée. La valeur par défaut est l'approbation automatique \"Jamais\".",
    automatic_values_required: "Texte d'affichage d'achèvement de planogramme requis",
    availability: "Disponibilité",
    availability_exceptions: "Exceptions de disponibilité",
    average_completed: "Moyenne terminée",
    average_completion: "% d'achèvement moyen",
    average_pay_rate: "Taux de rémunération moyen",
    average_pay_rate_dollars: "Taux de rémunération moyen (dollars)",
    average_time: "Temps moyen",
    average_time_minutes: "Temps moyen (minutes)",
    back: "Arrière",
    bar: "Barre",
    based_available_data_no_visualizations_generated: "En fonction des points de données disponibles, aucune visualisations ne peut être générée.",
    based_on_project_due_date: "Basé sur la date d'échéance de votre projet",
    based_on_project_progress: "En fonction de l'avancement de vos projets",
    basic_details_title: "Détails de base",
    basic_setting: "Réglage de base",
    basic_settings: "Paramètres de base",
    basic_work_details_title: "Détails de base du travail",
    batch_edit_locations: "Modifier les emplacements",
    bcc_recipients: "Destinataires en copie cachée",
    before_work_is_due: "Avant la fin des travaux",
    beginning_of_range_must_be: "Le début de la plage doit être inférieur à la fin de la plage",
    billing: "Facturation",
    billing_address: "Adresse de facturation Rue 1",
    billing_address_2: "Adresse de facturation Rue 2",
    billing_city: "Ville de facturation",
    billing_code: "Code de facturation",
    billing_codes: "Codes de facturation",
    billing_codes_label: "Code(s) de Facturation",
    billing_country: "Pays de facturation",
    billing_details_title: "Détails de facturation",
    billing_number: "Numéro de facturation",
    billing_pay_title: "Facturation et salaire",
    billing_rate: "Taux de facturation",
    billing_rate_help: "Entrez le taux de facturation du projet en fonction de votre sélection de type de facturation.",
    billing_state: "Etat de facturation Provence",
    billing_type: "Type de facturation",
    billing_type_help_flat: "Facturation basée sur un montant fixe pour chaque soumission de travail.",
    billing_type_help_hourly: "Facturation basée sur les heures travaillées par le personnel.",
    billing_type_help_none: "Montants facturables non suivis.",
    billing_type_help_title: "La sélection du type de facturation détermine la méthode de facturation client pour le travail du projet:",
    billing_zip: "Code postal de facturation",
    both_carrier_and_tracking_numbers_is_required: "Le ou les numéros de transporteur et de suivi sont requis",
    both_due_date_and_due_time_is_required: "La date d'échéance et l'heure d'échéance sont requises",
    both_pay_type_and_pay_rate_is_required: "Le type de rémunération et le taux de rémunération sont requis",
    both_start_date_and_start_time_is_required: "La date et l'heure de début sont requises",
    brand: "Marque",
    breadcrumb_trail: "Chemin de navigation",
    broker: "Courtier",
    browse: "Feuilleter",
    bulk_actions: "Actions en bloc",
    bulk_edit_visit_details: "Modification groupée des détails de la visite",
    bulk_management: "Gestion groupée",
    bulk_options: "Options en Vrac",
    bulk_update_attributes: "Attributs de mise à jour en masse",
    button_to_create_opportunities: "bouton pour créer des opportunités.",
    button_to_get_started: "bouton pour commencer",
    by_enabling_exchange: "En activitant l'échange, vous donnez des droits au partage de données dans votre domaine",
    by_movista: "Par Movista",
    by_navigating_on_this_site_you_agree_and_consent_to_our_user: "En naviguant sur ce site, vous acceptez et consentez à notre utilisateur ",
    calendar_preview: "Aperçu du calendrier",
    calender_preview: "Aperçu du calendrier",
    canada: "Canada",
    cancel: "Annuler",
    cancel_reissue: "Annuler la réédition",
    canceled: "Annulé",
    capital_unit_of_measure: "Milles",
    card_id: "ID de la carte",
    carrier: "Transporteur",
    cashier: "La caissière",
    category: "Catégorie",
    cell_phone: "Téléphone Portable",
    chain: "Détaillant",
    chains: "Détaillants",
    changes_published: "Modifications publiées",
    changes_saved: "Changements sauvegardés",
    changing_the_input_type_will_require_staff_to_be_reassigned: "La modification du type d'entrée requiert que le personnel soit réaffecté à toutes les valeurs d'attribut sous",
    characters: "Personnages",
    check_in_slash_check_out_time: "Heure d'arrivée / de départ",
    check_in_slash_out_time: "Heure d'arrivée / de départ",
    check_in_time: "Heure d'arrivée",
    checked_in: "Enregistré",
    cities: "Villes",
    city: "Ville",
    clear: "Claire",
    clear_cache: "Effacer le cache de session",
    clear_chart_filter: "Effacer le filtre graphique",
    clear_filters: "Effacer les filtres",
    clear_search: "effacer la recherche",
    clear_selection: "Effacer la sélection",
    clear_selections: "Effacer la sélections",
    click_here_to_download_csv_of_failed_locations_and_reupload: "Téléchargez le fichier CSV des emplacements ayant échoué et retéléchargez-le",
    click_ok_to_schedule_anyway: "Cliquez sur ok pour programmer quand même",
    click_on_a_photo_to_view_its_attributes: "Cliquez sur une photo pour voir ses attributs.",
    client: "Cliente",
    client_address: "Adresse du client Rue 1",
    client_address_additional: "Adresse du client Rue 2",
    client_code: "Code client",
    client_code_help: "Le code client est un identificateur unique attribué à un client pour suivre les interactions et les transactions. Il est généralement composé de lettres, de chiffres ou de symboles propres au client.",
    client_deleted_succesfully: "Client supprimé avec succès",
    client_details_title: "Détails du client",
    client_help: "Entrez n'importe quelle valeur pour un client que vous souhaitez associer à ce projet pour le rapport. Cette entrée est facultative.",
    client_id_invalid: "ID client non valide",
    client_label: "Cliente",
    client_list: "Liste des clients",
    client_manager: "Gestionnaire de clientèle",
    client_name: "Nom du client",
    client_name_invalid_tooltip: "Le nom du client ne peut pas correspondre à un autre enregistrement client",
    client_name_similar_tooltip: "Clients existants avec un nom similaire",
    client_number: "Numéro de client",
    client_number_help: "Le numéro de client est un identificateur unique attribué à un client pour gérer le compte du client et les identifier dans le système.",
    client_project_number_help: "Entrez n'importe quel numéro à associer à ce travail de projet. Ce numéro de projet peut être réutilisé dans plusieurs projets. Cette entrée est facultative.",
    client_project_number_label: "Client Projet #",
    client_status_help: "Affectez un statut de client pour contrôler la possibilité d'utiliser le client dans le portail Movista.",
    client_type: "Type de client",
    clients: "Clientèle",
    clocked_in: "Pointé(e) au début",
    close: "Fermer",
    club: "Club",
    club_time: "Heure du Club",
    column: "Colonne",
    columns: "Colonnes",
    communications: "Les Communications",
    company_settings: "Paramètres de l'entreprise",
    complete: "Terminé",
    complete_alert_help: "Gérez les projets qui incluront la demande supplémentaire pour valider le statut d'achèvement de la visite du projet dans l'application. Si cette option est activée, lorsqu'une visite de projet est soumise dans l'application, le personnel recevra une demande de confirmation d'achèvement supplémentaire.",
    complete_planogram: "Planogramme complet",
    completed: "Yerminé",
    completed_date: "Date d'achèvement",
    completed_date_filter_required: "Filtre de date de fin requis",
    completed_planogram: "J'ai terminé le planogramme.",
    completed_projects: "Projets achevés",
    completed_projects_default: "Des projets terminés. Ces projets ne fourniront plus l'état de santé.",
    completion_details: "Détails d'achèvement",
    completion_overview: "Aperçu de l'achèvement",
    condition: "État",
    conditional_logic: "Logique Conditionnelle",
    configuration_set: "Jeu de configurations",
    configure_default_date: "Configurer la date par défaut",
    configure_maximum_date: "Configurer la date maximale",
    configure_minimum_date: "Configurer la date minimale",
    confirm: "Confirmer",
    confirm_activate_rep_title: "Activer le membre du personnel",
    confirm_cancel: "Confirmer Annuler",
    confirm_delete: "Confirmation de la suppression",
    confirm_delete_announcement_dialog_title: "Voulez-vous vraiment supprimer cette annonce?",
    confirm_discard: "Confirmer le rejet",
    confirm_end_mplan: "Confirmer : la fin du projet",
    confirm_invitation_deletion_body: "La personne invitée ne pourra plus s'inscrire à Movista à l'aide du courriel qu'elle a reçu.",
    confirm_invitation_deletion_title: "Etes-vous sûr de vouloir supprimer l'invitation?",
    confirm_publish_draft: "Voulez-vous activer ce projet ?",
    connection_details: "Détails de la connexion",
    connection_id: "ID connexion",
    connection_initiating_instruction: "Vous êtes sur le point d'initier cette connexion. Pour afficher l'état de votre demande de connexion, consultez l'écran Client Manager Exchange.",
    connection_name: "Nom de la connexion",
    connections: "Connexions",
    connections_instruction: "Sélectionnez un client existant dans votre liste de clients. Si vous ne voyez pas le client que vous recherchez, ajoutez-le <ici>.",
    connections_instruction_2: "Pour lancer la connexion côté client, fournissez l'adresse e-mail de contact Exchange pour leur envoyer un lien d'activation.",
    contact: "Contact",
    contact_details_title: "Détails du contact",
    contact_manager_sentence: "Contactez votre responsable si vous pensez que vous n'avez pas les bons identifiants de connexion.",
    contact_name: "Nom du contact",
    contacts: "Contacts",
    contains_invalid_characters: "Contient des caractères non valides",
    continue: "Continuez",
    control_response_values: "Valeurs de réponse de contrôle",
    conversation_deactivated: "Cette conversation a été désactivée.",
    copied_clipboard: "Copié dans le presse-papier",
    copy: "Copie",
    copy_and_create_new: "Copier et Créer un Nouveau",
    copyright: "droits d'auteur",
    could_not_load_people: "Impossible de charger les personnes.",
    count: "Comptage",
    countries: "Des pays",
    country: "Pays",
    create: "Créer",
    create_a_project: "Créer un projet",
    create_a_section: "Créer une rubrique,",
    create_a_template: "Créer un Modèle",
    create_additional_opportunities: "Créer des opportunités supplémentaires",
    create_an_attribute: "Créer un attribut,",
    create_announcement: "Créer une annonce",
    create_announcements: "Créer des annonces",
    create_connection: "Créer une connexion",
    create_custom_field: "Créer un champ personnalisé",
    create_description_help: "Saisissez une description des travaux du projet à réaliser. Cela ne sera visible que dans la plate-forme Web et non dans l'application.",
    create_gallery: "Créer une Galerie",
    create_item_set: "Créer un ensemble d'articles",
    create_item_set_summary: "Définissez un groupe d'éléments associés, qui peut être utilisé pour créer des questions d'enquête basées sur des éléments.",
    create_list: "Créer une liste",
    create_message_back: " dans le coin supérieur droit.",
    create_message_front: "Créez un nouveau message en appuyant sur le bouton ",
    create_new: "Créer nouveau",
    create_new_announcement: "Créez une nouvelle annonce maintenant!",
    create_new_custom_field: "Créer un nouveau champ personnalisé",
    create_new_item_set: "Créer un ensemble d'articles",
    create_new_list: "Créer une nouvelle liste",
    create_new_people_attribute: "Créer un nouvel attribut de personne",
    create_new_report: "Créer un nouveau rapport",
    create_note: "Créer Note",
    create_opportunities: "Créer des opportunités",
    create_photo_gallery: "Créer une Galerie de Photos",
    create_project: "Créer un projet",
    create_report: "Créer un rapport",
    create_survey: "Créer Une Enquête",
    create_tag: "Créer une balise",
    create_template: "Créer Modèle",
    create_work: "Créer un travail",
    created_by: "Créé par",
    created_date: "Date de création",
    created_on: "Créé sur",
    creator: "Créateur",
    criteria: "Critère",
    csv: "CSV",
    cumulative_photo: "Photo cumulée",
    cumulative_response: "Réponse Cumulée",
    cumulative_responses: "Réponses Cumulées",
    cumulative_sbl_photo: "Photo SBL cumulée",
    cumulative_sbl_response: "Réponse SBL cumulée",
    current_branch: "Branche",
    current_calendar: "Calendrier Actuel",
    current_location: "Localisation Actuelle",
    custom: "customisées",
    custom_attributes: "Attributs personnalisés",
    custom_date: "Date personnalisée",
    custom_date_explanation: "Utiliser une date personnalisée comme date par défaut",
    custom_end_date: "Date de fin personnalisée",
    custom_field: "Champ personnalisé",
    custom_field_delete_end: "A été supprimé.",
    custom_field_values_save_failed: "Échec de l'enregistrement des valeurs de champ personnalisé",
    custom_field_values_saved_successfully: "Valeurs de champs personnalisés enregistrées avec succès",
    custom_fields: "Champ personnalisés",
    custom_unit_label: "étiquette d'unité personnalisée",
    customer_service: "Service client",
    daily: "Quotidien",
    daily_recurring_error: "Une répétition quotidienne ne peut pas durer plus d'un jour.",
    dashboard: "Tableau de bord",
    dashboards: "Tableaux de bord",
    data_grid: "Grille de données",
    data_refresh_alert: "Données Actualisées. La page va maintenant être rechargée",
    data_set_too_large_select_to_search: "Jeu de données trop volumineux. Sélectionner pour rechercher",
    data_sets_too_large_adjust_filters: "Les ensembles de données ci-dessous sont trop volumineux. Afin de vous offrir la meilleure expérience, ajustez les filtres pour les ensembles de données suivants.",
    data_successfully_imported: "Données importées avec succès",
    data_warehouse: "Entrepôt de données",
    date: "Date",
    date_created: "Date de création",
    date_parameters_title: "Paramètres de date",
    date_question_explanation: "Ce type de question permet aux utilisateurs de l'application de soumettre une réponse de plage de dates, avec des configurations facultatives limitant les soumissions à une plage de dates de projet.",
    date_range: "Intervalle de dates",
    date_range_type: "Type de plage de dates",
    date_shipped: "Date d'expédition",
    date_slash_time: "Date / Heure",
    date_submitted: "Date de soumission",
    date_time_parameters_title: "Paramètres de date et d'heure",
    dates: "Dates",
    dates_and_times: "Dates et heures",
    day: "jour",
    day_of_the_month: "Jour du mois",
    day_of_the_week: "Jour de la semaine",
    day_option: "Journées",
    day_range_feedback: "Doit être compris entre 0 et 24",
    days: "jours",
    days_prior_to_due_date: "Jours avant la date d'échéance",
    days_remaining: "Jours restant",
    deactivate: "Désactiver",
    deactivate_client_body: "Aucune donnée client ne sera perdue. Vous pouvez réactiver ce client à tout moment.",
    deactivate_client_title: "Vous êtes sur le point de désactiver ce client",
    deactivate_tag: "Désactiver la balise",
    deactivated: "désactivé",
    dec: "Déc",
    decline_opportunity: "Refuser l'opportunité",
    decline_the_opportunity: "Déligne de l'opportunité",
    decommission: "Déclasser ",
    decommission_reps: "Déclasser les représentants",
    decommissioned_inactive: "Déclasser/Inactif",
    decommissioning_are_you_sure: "Es-tu sûr de vouloir faire ça? Cette action ne peut pas être annulée.",
    decommissioning_they_will_no_longer: "Ils n'auront plus accès au kiosque ou aux journaux de travail, et leurs informations ne seront plus disponibles.",
    decommissioning_this: "Déclasser ce",
    decommissioning_these_reps: "Déclasser ces représentants ",
    decommissioning_will_remove_status: "retirera leur statut de représentant Movista.",
    default: "Défaut",
    default_cannot_be_greater_than_max: "La valeur par défaut ne peut pas être supérieure à la valeur maximale.",
    default_cannot_be_less_than_min: "La valeur par défaut ne peut pas être inférieure à la valeur minimale.",
    default_cannot_be_less_than_min_greater_than_max: "La valeur par défaut ne peut pas être inférieure à la valeur minimale et ne peut pas être supérieure à la valeur maximale.",
    default_date: "Date par défaut",
    default_date_explanation: "Utiliser la date par défaut définie",
    default_value: "Valeur Par Défaut",
    delete: "Supprimer",
    delete_a_job: "Supprimer un travail",
    delete_announcement: "Supprimer l'annonce",
    delete_announcement_dialog_title: "Êtes-vous sûr de vouloir supprimer cette pièce jointe?",
    delete_attribute: "Supprimer l'attribut",
    delete_client: "Supprimer le client",
    delete_client_confirmation: "Vous êtes sur le point de supprimer un client",
    delete_client_dialog_title: "Voulez-vous vraiment supprimer ce client ?",
    delete_conversation: "Supprimer la conversation",
    delete_custom_field: "Supprimer une zone personnalisée",
    delete_custom_field_confirmation: "Etes-vous sûr de vouloir supprimer cette zone personnalisée?",
    delete_draft: "Supprimer le Brouillon",
    delete_draft_confirmation: "Vous êtes sur le point de supprimer un brouillon de projet",
    delete_draft_dialog_title: "Voulez-vous vraiment supprimer ce brouillon?",
    delete_event: "Supprimer l'événement",
    delete_for_everyone: "La suppression de cette annonce la supprimera pour tout le monde.",
    delete_gallery: "Supprimer la Galerie",
    delete_image: " Supprimer l'image",
    delete_invitation: "Supprimer l'invitation",
    delete_item_set: "Supprimer l'ensemble d'articles",
    delete_item_set_confirmation: "Etes-vous sûr de vouloir supprimer cet ensemble d'éléments ? Cette action ne peut pas être annulée.",
    delete_list: "Supprimer la liste",
    delete_list_confirmation: "Etes-vous sûr de vouloir supprimer cette liste?",
    delete_lists: "Supprimer les listes",
    delete_lists_confirmation: "Etes-vous sûr de vouloir supprimer ces listes?",
    delete_note: "Supprimer La Note",
    delete_order: "Supprimer la commande",
    delete_question: "Supprimer La Question",
    delete_questions: "Supprimer Les Questions",
    delete_recurring_event: "Supprimer l'événement récurrent",
    delete_recurring_event_confirmation: "Confirmation de la suppression de l'événement récurrent?",
    delete_report: "Supprimer La Rapport",
    delete_section: "Supprimer des rubriques",
    delete_selected_lists: "Supprimer les listes sélectionnées",
    delete_sent_dialog_title: "Voulez-vous vraiment supprimer ce annonce?",
    delete_template: "supprimer le modèle.",
    delete_template_confirmation: "Vous êtes sur le point de supprimer un modèle mPlan",
    delete_workgrid: "Supprimer mPlan",
    delete_workgrid_confirmation: "Vous êtes sur le point de supprimer un mPlan terminé",
    delete_workgrid_pending_confirmation: "Vous êtes sur le point de supprimer un mPlan en attente",
    deleting_this_parent_question_will_delete_all_of_its_child_questions: "Supprimer cette question parente supprimera toutes les questions conditionnelles qui en dépendent",
    deleting_this_template: "La suppression de ce modèle n'affectera pas les projets existants.",
    deleting_this_value_will_remove_it_from_all_user_profiles: "La suppression de cette valeur la supprimera de tous les profils utilisateur.",
    deleting_this_value_will_remove_it_from_this_section: "La suppression de cette valeur la supprimera de cette section.",
    department: "Département",
    description: "La description",
    deselect_all: "Tout Déselectionner",
    details: "Des détails",
    device_id: "Reference de l'appareil",
    device_miles: "Miles-unité",
    device_model: "Modèle d'appareil",
    device_os: "Système d'exploitation de l'appareil",
    device_rep_reported_variance: "Variance signalée par l'unité / la représentation",
    device_route_variance: "Variance unité / route",
    did_not_complete_planogram: "Je n'ai pas terminé le planogramme.",
    discard: "Jeter",
    discard_all_unsaved_changes: "Vous êtes sur le point d'annuler toutes les modifications non enregistrées.",
    discard_changes: "Annuler les modifications",
    disguise: "Déguisement",
    disguise_as_admin: "Déguisement Admin",
    disguise_as_user: "Déguisement User",
    dismiss: "Rejeter",
    display: "Afficher",
    display_values: "Valeurs D'affichage",
    distance: "La Distance",
    distance_to_store_kilometers: "Distance jusqu'au magasin (Kilomètres)",
    distance_to_store_miles: "Distance jusqu'au magasin (Milles)",
    distributor: "Distributeur",
    do_you_want_to_continue_reissuing_this_occurrence: "Voulez-vous continuer à réémettre cette occurrence?",
    dob: "Date de Naissance",
    does_not_exist: "n'existe pas",
    does_not_include_projects: "N'inclut pas les projets infinis, exclus, en attente ou terminés.",
    download: "Télécharger",
    download_jpg: "Télécharger JPG",
    download_png: "Télécharger PNG",
    download_template: "Télécharger le modèle",
    downloads: "Téléchargements",
    draft: "Brouillon",
    draft_announcements: "Vos brouillons d'annonces seront stockés ici.",
    draft_mplans: "Nom provisoire",
    draft_saved: "Brouillon enregistré",
    drafts: "Brouillons",
    drop_pdf_here_or: "Déposez votre PDF ici ou",
    drop_your_csv_here_or: "Déposez votre image ici ou ",
    drop_your_file_here_or: "Déposez votre fichier ici ou",
    drop_your_files_here_or: "Déposez vos fichiers ici ou",
    drop_your_image_here: "Déposez votre image ici ou",
    drop_your_xlsx_here_or: "Supprimez votre xlsx ici ou",
    drop_your_zip_here_or: "Déposez votre fichier zip ici ou",
    due: "Exigible",
    due_current_time_error: "La date/heure d'échéance doit être postérieure à la date/heure actuelle.",
    due_date: "Date d'échéance",
    due_date_help: "La date d'échéance par défaut du projet se termine à 00:01 à la date sélectionnée. Définissez une autre heure d'échéance définie si la dernière heure de début du travail doit être antérieure dans l'application mobile.",
    due_date_must_be_after_initial_start_date: "La ou les dates d'échéance doivent être postérieures à la ou aux dates de début initiales",
    due_date_past_error: "La date d'échéance ne peut pas être dans le passé.",
    due_date_time: "Date / heure d'échéance",
    due_dates: "Date(s) d'échéance",
    due_end_error: "La date d'échéance est postérieure à la date de fin récurrente.",
    due_on_month_end: "Dû à la fin du mois",
    due_start_time_error: "L'heure d'échéance ne peut pas être identique ou antérieure à l'heure de début.",
    due_time: "Heure d'échéance",
    duplicat_item_set_name: "Nom d'ensemble d'éléments en double",
    duplicate: "dupliquer",
    duplicate_all: "Dupliquer tout",
    duplicate_custom_field: "Dupliquer la zone personnalisée",
    duplicate_list_name: "Nom de liste en double",
    duplicate_schedule: "Horaire dupliqué",
    duplicate_value: "Valeur en double",
    duration: "Durée",
    dynamic_entry: "Saisie dynamique",
    each_display_value_must_have_reporting_value: "Chaque ligne avec une valeur d'affichage doit également avoir une valeur de rapport.",
    edit: "Éditer",
    edit_assignments: "Modifier les devoirs",
    edit_attachment: "Modifier la pièce jointe",
    edit_custom_field: "Editer une zone personnalisée",
    edit_draft: "Modifier le brouillon",
    edit_gallery: "Modifier la Galerie",
    edit_item: "Modifier L'article",
    edit_item_requests: "Modifier les demandes d'articles",
    edit_item_set: "Editer l'ensemble d'articles",
    edit_item_set_name: "Editer le nom de l'ensemble d'articles",
    edit_list_name: "Editer le nom de la liste",
    edit_location: "Modifier l'emplacement",
    edit_note: "Note éditée",
    edit_people_attribute: "Modifier l'attribut des personnes",
    edit_recurring_event: "Modifier l'événement récurrent",
    edit_reps: "Modifier les représentants",
    edit_roles: "Modifier les rôles",
    edit_super_admins: "Modifier Super Admins",
    edit_visit_details: "EModifier les détails de la visite",
    edit_visit_details_description: "Vous pouvez attribuer des informations spécifiques à la visite en téléchargeant le fichier modèle, en saisissant les détails de chaque emplacement et en important le fichier.",
    edit_visit_details_via_csv: "Modifier les détails de la visite via CSV",
    edit_visit_details_warning: "L'importation d'un nouveau fichier écrasera les détails de l'emplacement existant. Pour modifier les détails existants, téléchargez à nouveau le fichier. Les détails existants seront inclus dans le modèle.",
    edited_by: "Sous la direction",
    eg_entering_8_to_10_will_display_the_question_if_they_answer_8_9_or_10: "Ex: en entrant 8 à 10, la question s'affichera si la réponse est 8, 9 ou 10.",
    email: "Courrier électronique",
    email_address: "Adresse e-mail",
    email_address_list: "Entrez les adresses e-mail",
    email_error: "Format de courrier électronique incorrect",
    email_mplan_responses: "Réponses aux visites par e-mail",
    email_recipients: "Destinataire(s) du courriel",
    emails_receiving_alert: "Adresses électroniques recevant une alerte",
    emp_id: "ID Employé",
    employee: "Employé",
    employee_assigned: "Employé affecté",
    employee_details: "Détails de l'employé",
    employee_id: "ID d'employé",
    employee_name: "Nom de l'employé",
    empty_question_text: "Entrez le texte de votre question ici",
    enable_bulk_management: "Activer la gestion en masse",
    enabling_bulk_management_message: "L'activation de la gestion groupée activera l'utilisation des options de gestion groupée.",
    enable_client_manager: "Activer le gestionnaire client",
    enable_exchange: "Activer Exchange",
    enable_external_project_links: "Activer les liens de projet externes",
    enable_hierarchy: "Activer la hiérarchie du personnel",
    enable_hub: "Activer le concentrateur",
    enable_profile: "Activer le profil",
    enable_rep_hub: "Activer le concentrateur de personnes",
    enable_tag_manager: "Activer le gestionnaire de balises",
    enabling_rep_hub_will_turn_on: "Activation du concentrateur pour l'utilisation de l'Athena People Hub",
    enabling_rep_profile_will_turn_on: "Le profil d'activation va activer l'utilisation du profil de représentation Athena",
    end: "Finir",
    end_after_number_occurrences: "Fin après un certain nombre d'occurrences",
    end_date: "Date de Fin",
    end_date_explanation: "Utiliser la date de fin du projet",
    end_date_help: "Si le projet se termine à la date d'échéance, il se terminera à la date et à l'heure d'échéance saisies.",
    end_date_must_be_after_initial_start_date: "La ou les dates de fin doivent être postérieures à la ou aux dates de début initiales",
    end_date_time: "Date/heure de fin",
    end_dates: "Date(s) de fin",
    end_mplan_body: "Voulez-vous vraiment mettre fin à ce projet?",
    end_of_range_must_be: "La fin de la plage doit être supérieure au début de la plage",
    end_time: "Heure de fin",
    end_time_is_required: "La date de fin est requise",
    end_type: "Type de fin",
    end_type_changed_to_due_date: "Type de fin remplacé par \"Date d'échéance\"",
    ending_on: "terminant le",
    enforce_due_time: "Appliquer le délai d'échéance",
    enforce_start_time: "Appliquer l'heure de début",
    ensure_decimal_places_are_correct: "Vérifiez que les positions décimales sont correctes.",
    enter_connection_details: "Entrer les détails de connexion",
    enter_text: "Entrer le texte",
    enter_value_or_click_minus_button_to_delete: "Entrez la valeur ou cliquez sur le bouton moins pour supprimer",
    enter_values_for_this_attribute: "Entrez des valeurs pour cet attribut.",
    enter_values_here: "Entrez les valeurs ici",
    enter_values_into_boxes: "Entrez des valeurs dans la ou les zones de texte",
    enter_values_separated_by_a_comma_or_return: "Entrez des valeurs séparées par une virgule ou retournez",
    enter_your_own_threshold: "Entrez votre propre seuil",
    entry_date: "Date d'entrée",
    entry_date_explanation: "Utiliser la date actuelle de l'utilisateur de l'application",
    error_400: "Demande non valide",
    error_401: "Demande non autorisée",
    error_403: "Demande interdite",
    error_404: "Non trouvé",
    error_409: "Conflit",
    error_500: "Erreur du serveur",
    error_502: "Passerelle incorrecte",
    error_503: "Service non disponible",
    error_504: "Passerelle hors délai",
    error_507: "Espace insuffisant",
    error_message: "Nous ne sommes pas en mesure de répondre à votre demande pour le moment. Veuillez réessayer plus tard.",
    error_page_not_found: "Cette page est introuvable",
    error_page_not_found_text: "Le contenu que vous essayez d'atteindre a peut-être été supprimé ou vous n'y avez peut-être pas accès.",
    error_refreshing_data: "Whoops ! Une erreur s'est produite lors de l'actualisation des données",
    error_uploading_file: "Erreur lors du téléchargement du fichier sur le serveur",
    error_while_updating_estimated_time: "Erreur lors de la mise à jour du temps estimé",
    errors: "les erreurs",
    escalate_to_projects_assigned_roles: "Escalader vers les rôles attribués au projet",
    escalation_paths_based_off_staff_member_assigned: "Les voies d'escalade seront basées sur le membre du personnel qui a été affecté et seront triées par ordre chronologique.",
    estimated_rep_pay: "Rémunération estimée du représentant",
    estimated_time: "Temps estimé",
    estimated_time_in_minutes: "Temps estimé (minutes)",
    estimated_time_to_complete_work: "Temps estimé pour terminer le travail",
    event: "Evénement",
    event_details: "Détails de l'événement",
    events: "Evénements",
    every: "Tous",
    ex_items: "Ex: \"éléments\"",
    ex_namesite: "Ex. name@site.com",
    excel: "Excel",
    exchange: "Echange",
    exchange_client: "Client Exchange",
    exchange_contact: "Nom du contact Exchange",
    exchange_contact_email: "Courrier électronique du contact Exchange",
    exchange_email: "Courrier électronique d'échange",
    exchange_opt_in: "Opt Exchange dans",
    exclude_gps: "Excusez le GPS",
    excluded: "Exclus",
    excluded_project_default: "Les projets sont exclus de la fourniture d'un état de santé lorsque la durée du projet est inférieure à la durée spécifiée manuellement dans les paramètres de seuil.",
    excluded_projects: "Projets Exclus",
    excluded_threshold: "La durée de ce mPlan est inférieure à la durée spécifiée dans les paramètres de seuil.",
    execution_dashboard: "Tableau de bord d'exécution",
    existing_files: "Fichiers existants",
    expected_time: "Heure prévue",
    expense_id: "Identifiant de Frais",
    expenses: "Dépenses",
    expired: "Expiré",
    expires: "Expire",
    export: "Exportation",
    export_all: "Exporter toutes les colonnes",
    export_all_data: "Exporter toutes les données",
    export_assignments: "Exporter les affectations",
    export_calendar_and_schedule: "Exporter le calendrier et l'horaire",
    export_columns_selected_or_filtered_grid: "Exporter les colonnes comme sélectionnées ou filtrées dans la grille",
    export_contacts: "Exporter des contacts",
    export_csv: "Exporter CSV",
    export_draft: "Exporter le Brouillon",
    export_excel: "Exporter Excel",
    export_gallery: "Galerie d'exportation",
    export_item: "Article D'exportation",
    export_location_details: "Exporter les détails de l'emplacement",
    export_locations: "Emplacements D'exportation",
    export_notes: "Exporter des notes",
    export_opportunities: "Opportunités d'exportation",
    export_options: "Options d'exportation",
    export_pdf: "Exporter un PDF",
    export_people: "Exporter les personnes",
    export_photos: "Exporter des photos",
    export_powerpoint: "Exporter le Powerpoint",
    export_selected: "Exporter les colonnes comme sélectionnées ou filtrées dans la grille",
    export_selections: "Exporter les sélections",
    export_tags: "Exporter des balises",
    export_template: "Modèle d'exportation",
    export_work: "Exporter le travail",
    export_work_bank_visits: "Visites de la banque de travail à l'exportation",
    export_zip: "Exportation de Zip",
    external_project_links: "Liens externes du projet",
    failed: "Échoué",
    failed_location_imports: "échec des importations d'emplacements",
    failed_to_update_record: "Échec de la mise à jour de l'enregistrement",
    fails: "Échoue",
    feature_preferences: "Préférences des fonctions",
    features: "Fonctions",
    feb: "Févr",
    feedback: "Retour",
    field_is_required: "Champ requis.",
    file_attachment: "Pièce Jointe",
    file_name: "Nom de fichier",
    file_too_large_20: "Taille du fichier trop grande. Doit être inférieur à 20 Mo.",
    file_uploaded_successfully: "Fichier téléchargé avec succès",
    file_with_errors_cannot_be_imported_review_information_below: "Le fichier contenant des erreurs ne peut pas être importé. Consultez les informations ci-dessous.",
    files_uploaded: "Fichier(s) téléchargé(s)",
    files_uploaded_successfully: "fichier(s) téléchargé(s) avec succès",
    fill_out_the_following_fields_then_click_next: "Remplissez les champs suivants, puis cliquez sur Suivant.",
    fill_out_the_following_fields_then_click_save: "remplissez les_ champs suivants puis cliquez sur enregistrer",
    filter_by_assignment_value: "Filtrer par Valeur d'Affectation",
    filter_by_location: "Filtrer par emplacement",
    filter_by_person: "Filtrer par Personne",
    filter_by_project_identifiers: "Filtrer par Identifiants de Projet",
    filters: "Filtres",
    final_recurrence_due: "Récurrence finale due",
    final_recurrence_due_on: "Récurrence finale due le :",
    first: "premier",
    first_name: "Prénom",
    flat_rate: "Forfait",
    forklift_certification: "Certificat de chariot élévateur",
    forward: "Effronté",
    forward_message: "Transférer le message",
    fourth: "quatrième",
    frequency: "La fréquence",
    friday: "Vendredi",
    gallery_name: "Nom de la Galerie",
    gallery_options: "Options de la Galerie",
    gallery_refreshed: "Galerie actualisée",
    gallery_refreshing: "Mise à jour de la galerie",
    general: "Général",
    general_information: "Informations Générales",
    general_message: "Message Général",
    geographic_radius: "Rayon géographique",
    give_best_experience_enter_the_projects_to_view: "Pour vous offrir la meilleure expérience, vous devrez entrer les projets que vous souhaitez voir",
    give_best_experience_enter_the_rep_to_view: "Pour vous offrir la meilleure expérience, vous devrez entrer le représentant que vous souhaitez voir",
    global_dashboards: "Tableaux de bord mondiaux",
    global_reports: "Rapports globaux",
    go_to_desktop: "Vue de Bureau",
    go_to_mobile_site: "Aller Sur le Site Mobile",
    great_day: "Passe une bonne journée!",
    guid: "GUID",
    guids: "GUIDs",
    half_day: "Demi-journée",
    half_pie: "Demi-Pie",
    has_been_sucessfully_deleted: "a été supprimé avec succès",
    has_been_sucessfully_duplicated: "a été dupliqué avec succès",
    health: "Santé",
    health_overview: "Aperçu de la santé",
    hide_infinity: "Masquer l'infini",
    hide_insights: "Masquer les aperçus",
    hide_no_response: "Masquer les réponses sans réponse",
    hide_no_responses: "Masquer les réponses vides",
    hide_staff_name: "Masquer Le Nom Du Personnel",
    hierarchy: "Hiérarchie",
    high: "Haute",
    high_priority: "Haute Priorité",
    home_address: "Adresse du Domicile",
    home_phone: "Téléphone Fixe",
    hot_tasks: "Tâches prioritaires",
    hour: "heure",
    hourly: "Heure",
    hours: "les heures",
    hours_option: "Les heures)",
    how_long_this_project_take_to_complete: "Combien de temps ce projet devrait-il prendre pour être réalisé?",
    how_often_should_this_project_be_completed: "À quelle fréquence ce projet doit-il être réalisé ?",
    how_would_you_like_to_end_this_project: "Comment aimeriez-vous terminer ce projet ?",
    html_response: "La réponse HTML n'est pas valide.",
    hub: "Moyeu",
    hundred_percent_submitted: "100 % soumis",
    i_accept: "J'accepte",
    i_dont_know_which_login_to_use: "Je ne sais pas quel login utiliser",
    i_forgot_my_username_or_password: "J'ai oublié mon nom d'utilisateur ou mon mot de passe.",
    ie_android_ios: "c'est-à-dire Android, iOS",
    ie_device_os: "c'est-à-dire l'Os de l'appareil",
    ie_personal_device_corporate_device: "c'est-à-dire appareil personnel, appareil d'entreprise",
    if_work_is_not_submitted_by: "Si le travail n'est pas soumis par",
    image_attached: "Image ci-jointe",
    image_default_error: "Erreur lors du téléchargement de l'image sur le serveur",
    image_too_large: "Taille du fichier trop grande. Doit être inférieur à 5 Mo.",
    import: "Importer",
    import_a_csv_to_bulk_select_a_set_of_location_numbers: "Importez un CSV pour sélectionner en bloc un ensemble de numéros d'emplacement.",
    import_attributes: "Importer des attributs",
    import_error_msg: "Type de fichier non pris en charge. Veuillez télécharger un fichier JPG ou PNG.",
    import_errors: "Importer des erreurs",
    import_invitations: "Importer",
    import_item_updates: "Importer les mises à jour des articles",
    import_items: "Importer des articles",
    import_location_data: "Importer les données de localisation",
    import_locations: "Importer des emplacements",
    import_new_locations: "Importer de nouveaux emplacements",
    import_preferred_reps: "Importer des représentants préférés",
    import_primary_rep_location: "Importer l'emplacement du représentant principal",
    import_roles: "Importer des rôles",
    import_schedule: "Calendrier d'importation",
    import_title_tool_tip_text: "Les MVID des éléments actuels dans l’ensemble d’éléments sont répertoriés ci-dessous. Pour supprimer un élément, définissez son action sur Supprimer. Pour ajouter un élément, ajoutez son MVID sur une nouvelle ligne et définissez l'action sur Ajouter. Les éléments sans action ne seront pas affectés.",
    import_unsuccessful_please_review_errors: "Échec de l'importation - Veuillez vérifier les erreurs",
    import_update_location_availability: "Importer les mises à jour de la disponibilité des emplacements des articles",
    import_update_location_specific_attributes: "Importer les mises à jour des attributs spécifiques des articles",
    importing_locations_this_may_take_a_while: "Importer des emplacements, cela peut prendre un certain temps...",
    in_progress: "En cours",
    inactive: "Inactif",
    inbox: "Boîte de réception",
    include_additional_visit_details: "Inclure les détails supplémentaires de la visite",
    include_custom_fields_in_the_template: "Inclure des champs personnalisés dans le modèle",
    include_display_values: "Inclure les Valeurs D'affichage",
    include_reps_who_previously_declined: "Inclure les représentants qui ont précédemment refusé",
    include_reps_who_previously_declined_tooltip: "Si cette option est activée, les représentants qui ont précédemment refusé visite seront inclus dans la sélection des visites.",
    include_the_submitted_answers_and_item_count_responses_in_this_reissue: "Inclure les réponses soumises et les réponses au nombre d'articles dans cette réédition",
    incomplete_planogram_reasons: "Raisons de planogramme incomplète",
    incomplete_planogram_summary: "Veuillez fournir un raisonnement pour ne pas être en mesure de compléter le planogramme.",
    incorrect_planogram_evaluation: "Non: Evaluation de planogramme incorrecte",
    infinity: "Infini",
    infinity_mplans_can_be_scheduled_more_than_once: "Les plans mPlans Infinity peuvent être planifiés plus d'une fois",
    infinity_opportunities_unavailable: "Les opportunités ne sont pas disponibles avec les projets Infinity. Pour activer les opportunités, remplacez le Type de projet par Standard.",
    infinity_project_default: "Des projets qui ont un nombre infini de visites possibles. ces projets n'auront pas d'état de santé en raison de la variabilité du projet.",
    infinity_projects: "Projets à l'infini",
    infinity_projects_support: "Les projets Infinity prennent en charge les types de fin \"Date d'échéance\" et \"Manuel\"",
    infinity_work_does_not_support_this_feature: "Infinity Work ne prend pas en charge cette fonctionnalité",
    input_type: "Type d'entrée",
    insights: "Connaissances",
    instructions_title: "Des instructions",
    interval: "intervalle",
    invalid_characters: "Caractères invalide(s)",
    invalid_characters_include: "Les caractères non valides incluent",
    invalid_date: "Date invalide",
    invalid_date_range: "Plage de dates non valide",
    invalid_email: "Email invalide",
    invalid_end_time: "Heure de fin non valide",
    invalid_location_numbers_will_not_be_saved: "Numéro(s) de lieu non valides - ne seront pas enregistrés:",
    invalid_object: "Objet de demande non valide",
    invalid_template: "Modèle invalide",
    invalid_tooltip: "L'entrée ne peut pas correspondre à un autre enregistrement",
    invalid_url: "URL non valide",
    invite_from_csv: "Inviter De CSV",
    invite_reps: "Inviter Un Représentant",
    invite_resend_success_message: "A reçu un nouveau code d'enregistrement.",
    invited: "Invité",
    invited_on: "Invité le",
    is: "Est",
    is_between: "Est Entre",
    is_not: "N'est Pas",
    is_not_valid: "n'est pas valide",
    issue_overview: "Aperçu du problème",
    issue_status: "Statut du Problème",
    item_actions: "Actions des articles",
    item_catalog: "Catalogue des articles",
    item_count: "Nombre d'éléments",
    item_count_request: "Demande de comptage d'articles",
    item_count_requests: "Demande de comptage d'articles",
    item_grid: "Grille d'articles",
    item_id: "ID article",
    item_maintenance: "Maintenance des articles",
    item_manager: "Gestionnaire d'article",
    item_out_of_stock: "Non: Article hors stock",
    item_request_manager: "Gestionnaire de Demandes d'Articles",
    item_request_name: "Nom de la demande d'article",
    item_requests_title: "Demande d'articles",
    item_set_name: "Nom de l'ensemble d'articles",
    item_set_template: "Modèle d'ensemble d'articles",
    item_sets: "Ensembles d'articles",
    items: "Articles",
    items_added_from_my_tools: "Élément(s) ajouté(s) à partir de \"Mes outils\"",
    items_selected: "Eléments sélectionnés",
    jan: "Janv",
    job: "Travail",
    job_code: "Code du Travail",
    job_id: "ID de travail",
    jul: "Juil",
    jun: "Juin",
    keep_typing_to_see_results: "Conserver la saisie pour afficher les résultats",
    language: "Langue",
    language_change_alert: "Whoops ! Une erreur s'est produite lors de la communication avec le serveur",
    last_30_days: "30 derniers jours",
    last_90_days: "90 derniers jours",
    last_active: "Dernier Actif",
    last_edited: "Dernière modification",
    last_edited_by: "Dernière modification par",
    last_edited_date: "Date de la dernière modification",
    last_fourteen_days: "14 derniers jours",
    last_login: "Dernière connexion",
    last_name: "Nom de Famille",
    last_ninety_days: "90 derniers jours",
    last_project_activity: "Dernière Activité Projet",
    last_run: "Dernière exécution",
    last_run_date: "Date de la dernière exécution",
    last_seven_days: "7 derniers jours",
    last_thirty_days: "30 derniers jours",
    last_updated_by: "Dernière mise à jour par",
    last_updated_on: "Dernière mise à jour le",
    last_x_days: "{number} derniers jours",
    late: "En retard",
    late_status: "Statut tardif",
    latest_start: "Dernier démarrage",
    latestatus_default_details: "Le projet sera signalé comme étant en retard si chaque emplacement n'est pas terminé et soumis à la date d'échéance.",
    latestatus_manual_details: "Le projet sera signalé comme étant en retard en fonction de vos spécifications. Cette option est utile si vous souhaitez qu'un projet soit marqué comme En retard avant sa date d'échéance. Choisissez le nombre de jours avant la date d'échéance et le seuil de pourcentage de soumission que vous souhaitez que le projet atteigne, sinon il sera signalé comme étant en retard.",
    latitude: "Latitude",
    latitudes: "Latitudes",
    launch: "Lancer",
    launch_1hub: " Lancer 1Hub",
    launch_amp: "Lancer AMP",
    launch_app: "Lancer l'application",
    launch_one: "Lancer One",
    left_conversation: "quitté la conversation",
    legacy_csv: "CSV Hérité",
    legacy_locations_hub: "Centre d'emplacements hérités",
    legacy_reporting_center: "Centre de gestion des rapports hérité",
    less_than: "Inférieur à",
    lets_find_your_items: "Permet De Trouver Vos Articles",
    lets_find_your_locations: "Trouvons vos emplacements",
    lift_fifty_plus: "Soulevez 50+ LBS",
    limit_any_numeric_entries_in_the_app: "Limiter les entrées numériques de l'application. Les valeurs n'ont pas de limites et peuvent inclure des nombres négatifs ou des points décimaux.",
    link_name: "Nom du lien",
    link_status: "Statut du lien",
    link_url: "URL du lien",
    links_added: "Lien(s) ajouté(s)",
    list: "Liste",
    list_name: "Liste de noms",
    lists: "Listes",
    loading: "Chargement",
    location: "Site",
    location__s: "Emplacements)",
    location_address: "Adresse de l'emplacement",
    location_address_two: "Adresse de l'emplacement 2",
    location_assigned: "Emplacement affecté",
    location_based: "Basé sur l'emplacement",
    location_count: "Nombre d'Emplacements",
    location_custom_fields: "Zones personnalisées de l'emplacement",
    location_details: "Détails de l'emplacement",
    location_id: "ID d'emplacement",
    location_ids: "IDs d'emplacement",
    location_info: "Informations sur l'emplacement",
    location_list: "Liste des emplacements",
    location_lists: "Listes des emplacements",
    location_mvid: "Emplacement MVID",
    location_name: "Nom de L'emplacement",
    location_number: "L'emplacement #",
    location_number_long: "Numéro d'emplacement",
    location_number_text: "Numéro d'emplacement",
    location_numbers: "Numéros d'emplacement",
    location_phone_number: "Numéro de téléphone de l'emplacement",
    location_timezone: "Fuseau horaire de l'emplacement",
    locations: "Sites",
    locations_added: "Emplacements ajoutés",
    locations_and_projects: "Emplacements et Projets",
    locations_assigned: "emplacements attribués",
    location_assignments: "Attributions d'emplacement",
    locations_assigned_capitalized: "Emplacements Affectés",
    locations_edited: "Emplacements modifiés",
    locations_export: "Exportation des emplacements",
    locations_hub: "Hub d'emplacements",
    locations_imported: "Emplacements Importés",
    locations_only: "Emplacements seulement",
    locations_selected: "Emplacements sélectionnés",
    login: "Connexion",
    login_id: "Connexion ID",
    logout: "Déconnexion",
    longitude: "Longitude",
    longitudes: "Longitudes",
    looker: "Looker",
    low: "Faible",
    low_priority: "Priorité basse",
    lsq_tip_no_locations: " Pour pouvoir attribuer des questions spécifiques à un emplacement, il faut d'abord ajouter des emplacements au projet.",
    lsq_tip_with_locations_end: "Cliquez sur le bouton ci-dessous pour spécifier les emplacements où cette question est posée.",
    lsq_tip_with_locations_start: "Cette question sera posée à tous les endroits.",
    lsq_tooltip: "Cette question n'est disponible qu'à certains endroits.",
    m_plan_info: "Infos sur le mPlan",
    maintain_recurrence_duration: "Maintenir la durée de récurrence",
    make_response_visibility_private: "Rendre la visibilité des réponses privée",
    make_the_question_location_specific: "Définir l'emplacement de la question-Spécifique",
    manage_locations: "Gérer les emplacements",
    manage_order: "Gérer la commande",
    manage_roles: "Gérer les rôles",
    manage_tools: "Gérer les outilsv",
    management_portal: "Portail de gestion",
    manager: "Directeur",
    manager_email: "E-mail du responsable",
    manager_help: "Sélectionnez n'importe quel utilisateur que vous souhaitez associer en tant que responsable à ce travail de projet pour la création de rapports. Cette entrée est facultative.",
    manager_info: "Info sur le Gestionnaire",
    manager_information: "Informations sur le Gestionnaire",
    manager_label: "Gestionnaire",
    manager_name: "Nom du responsable",
    manager_phone_number: "Numéro de téléphone du responsable",
    managers: "Gestionnaires",
    managers_login_question_information: "Les informations d'identification de connexion des gestionnaires sont une combinaison de lettres et éventuellement de chiffres.",
    managers_only: "Gestionnaires uniquement",
    manual: "Manuel",
    manual_entry: "Saisie manuelle",
    manually_enter_values_to_select_location_numbers: "Saisissez manuellement des valeurs pour effectuer une sélection groupée d'un ensemble de numéros d'emplacement.",
    manufacturer: "Fabricant",
    manufacturers: "Fabricants",
    mar: "Mars",
    mark_as_high_priority: "Marquer comme Haute Priorité",
    marked_complete: "Marqué comme terminé",
    master_question: "Question Principale",
    master_questions: "Questions Principales",
    max_cannot_be_greater_than_allowed_max: "La valeur maximale ne peut pas être supérieure à la valeur maximale de la question parente",
    max_cannot_be_less_than_default: "La valeur maximale ne peut pas être inférieure à la valeur par défaut.",
    max_custom_fields_reached: "Nombre maximal de champs personnalisés atteint (30).",
    max_daily_hours: "Heures quotidiennes max",
    max_must_be_greater_than_min: "La valeur maximale doit être supérieure à la valeur minimale.",
    max_must_be_greater_than_min_cannot_be_less_than_default: "La valeur maximale doit être supérieure à la valeur minimale et ne peut pas être inférieure à la valeur par défaut.",
    max_weekly_hours: "Heures hebdomadaires max",
    maximum_character_limit_reached: "Limite maximale de caractères atteinte",
    maximum_value: "Valeur Maximum",
    maximum_value_also_required: "Une valeur maximale est également requise.",
    may: "Mai",
    media_max: "Maximum: 20 Mo",
    media_title: "Médias",
    media_types: "BMP, CSV, DOC, DOCX, GIF, HTM, HTML, JPG, JPEG, MOV, MP3, MP4, PNG, PDF, PPT, PPTX, RTF, TXT, WAV, WMV, XLS, XLSX, & ZIP.",
    merchandiser: "Marchandiseur",
    message: "Un message",
    message_error: "Un problème est survenu lors de l'envoi de votre message. Cliquez sur les options de message pour réessayer.",
    message_group: "Groupe de messages",
    messages: "Messages",
    messaging: "Messagerie",
    mileage_comparison: "Comparaison des kilométrages",
    min_cannot_be_greater_than_default: "La valeur minimale ne peut pas être supérieure à la valeur par défaut.",
    min_cannot_be_greater_than_default_must_be_less_than_max: "La valeur minimale ne peut pas être supérieure à la valeur par défaut et doit être inférieure à la valeur maximale.",
    min_cannot_be_less_than_allowed_min: "La valeur minimale ne peut pas être inférieure à la valeur minimale de la question parente",
    min_must_be_less_than_max: "La valeur minimale doit être inférieure à la valeur maximale.",
    minimum_age: "âge minimum",
    minimum_billable_time: "Temps facturable minimum",
    minimum_billable_time_help: "S'il y a lieu, inscrivez la durée facturable minimale, en minutes, pour chaque visite de travail soumise, peu importe le temps de travail réel.",
    minimum_payable_time: "Durée minimale de paiement",
    minimum_payable_time_help: "S'il y a lieu, inscrivez la durée minimale de paie, en minutes, pour chaque visite de travail soumise, peu importe le temps de travail réel.",
    minimum_value: "Valeur Minimum",
    minimum_value_also_required: "Une valeur minimale est également requise.",
    minutes: "minutes",
    missed: "Manqué",
    missing_fixtures: "Non: Dispartages manquants",
    missing_skills_and_capabilities: "Compétences et capacités manquantes",
    mm_dd_yy: "MM/JJ/AA",
    mm_dd_yyyy: "MM/JJ/AAAA",
    mobile: "Mobile",
    mobile_alert: "Envoyer une alerte si un utilisateur mobile",
    mobile_manager_view: "Application mobile - Vue du gestionnaire",
    mobile_phone: "Téléphone Mobile",
    monday: "Lundi",
    month: "mois",
    monthly: "Mensuel",
    monthly_recurring_end_error: "Une récurrence mensuelle qui est due le dernier jour du mois ne peut pas commencer plus tard que le 27e jour du mois.",
    monthly_recurring_error: "Une récurrence mensuelle ne peut pas durer plus d'un mois.",
    monthly_recurring_start_error: "Une récurrence mensuelle ne peut pas commencer plus tard que le 28e jour du mois.",
    monthly_recurring_week_error: "Une récurrence mensuelle ne peut pas se terminer plus tard que le 28e jour du mois, sauf si Échéance à la fin du mois est sélectionné.",
    months: "mois",
    more_filters: "Plus de filtres",
    movista_inc_all_rights_reserved: "Movista Inc. Tous droits réservés.",
    mplan_details: "Détails du mPlan",
    mplan_identifier: "Identifiant mPlan",
    mplan_name: "Nom du mPlan",
    mplan_question: "Question mplan",
    mplan_responses: "Réponses mPlan",
    mplan_responses_link: "Lien Réponses mPlan",
    mplan_status: "Statut mPlan",
    mplan_submission_link: "Lien de soumission mPlan",
    mplan_tags: "Étiquette mPlan",
    mplan_template_types: "Types de modèle mPlan",
    mplan_type: "Type de mPlan",
    mplans: "mPlans",
    multi_select: "Sélection Multiple",
    multi_select_dash: "Sélection-Multiple",
    multiple_choice: "Choix Multiple",
    must_have_a_survey_with: "doit avoir une enquête avec",
    mv_id: "ID MV",
    mvid: "MVID",
    mvids: "MVIDs",
    my_tools: "Mes outils",
    n_a: "N/A",
    name: "Nom",
    needs: "besoin",
    needs_configuration: "Configuration requise",
    needs_review: "Examen des besoins",
    never: "Jamais",
    new: "NOUVELLE",
    new_activities_next_week: "Nouvelles activités prévues pour la semaine prochaine",
    new_activities_this_week: "Nouvelles activités prévues pour cette semaine",
    new_activity_next_week: "Nouvelle activité prévue pour la semaine prochaine",
    new_activity_scheduled_for: "Nouvelle activité prévue pour",
    new_attribute: "Nouvel attribut",
    new_custom_field: "Nouveau champ personnalisé",
    new_escalation_alert: "Nouvelle alerte d'escalade",
    new_item_set: "Nouvel ensemble d'articles",
    new_list: "Nouvelle liste",
    new_message: "Nouveau message",
    new_mplan: "Commencer un nouveau mPlan",
    new_note: "Nouvelle Note",
    new_range: "Nouvelle Gamme",
    new_recurring_event: "Nouvel événement récurrent",
    new_response_value: "Nouvelle Valeur De Réponse",
    new_section: "Nouvelle rubrique",
    new_sub_section: "Nouvelle sous-section",
    new_value: "Nouvelle valeur",
    next: "Suivant",
    next_30_days: "30 prochains jours",
    next_7_days: "7 prochains jours",
    next_seven_days: "7 jours suivants",
    next_sixty_days: "60 jours suivants",
    no: "Non",
    no_active: "Aucun actif",
    no_active_tags: "Aucune balise active",
    no_activity_log_found: "Aucun journal d'activité trouvé",
    no_angle_brackets: "Pas d'équerres.",
    no_announcements: "Pas encore d'annonces",
    no_attributes: "Aucun attribut",
    no_clients_found: "Aucun client dans les filtres définis",
    no_conversations: "Aucune conversation pour le moment",
    no_created_templates: "Aucun modèle n'a encore été créé",
    no_custom_fields_to_display: "Aucune zone personnalisée dans les filtres définis",
    no_data_available: "Aucune donnée disponible",
    no_data_found: "Aucune donnée dans les filtres définis",
    no_data_in_csv: "Pas de données au format CSV",
    no_data_to_be_visualized: "Aucune donnée disponible à visualiser",
    no_data_to_display: "Aucune donnée à afficher",
    no_description: "--",
    no_display_text: "Texte de l'option de réponse-Planogramme non terminé",
    no_drafts: "Pas encore de brouillon",
    no_end_date: "Pas de date de fin",
    no_exceptions_submitted: "Aucune exception soumise.",
    no_existing_files_uploaded: "Aucun fichier existant n'a été téléchargé",
    no_existing_item_requests: "Il n'y a pas de demandes d'articles existantes.",
    no_filtered_results: "Aucun résultat dans les filtres définis.",
    no_inactive_reps_to_display: "Aucune Reps Inactive à afficher",
    no_instructions: "Il n'y a pas d'instructions pour ce projet.",
    no_invited_reps_from_filter: "Personne dans le filtre défini",
    no_invited_reps_from_filter_body: "Veuillez ajuster la recherche pour remplir les données ou ",
    no_invited_reps_to_display: "Aucun personnel à afficher",
    no_item_sets: "Aucun ensemble d'articles",
    no_item_sets_found: "Aucun ensemble d'articles trouvé",
    no_items_found: "Aucun article trouvé",
    no_items_selected: "Aucun élément sélectionné",
    no_items_to_display: "Aucun élément à afficher",
    no_lists_found: "Aucune liste dans les filtres définis",
    no_lists_to_display: "Aucune liste à afficher",
    no_location_found: "Aucun emplacement dans les filtres définis",
    no_locations_to_display: "Aucun emplacement à afficher",
    no_matches_based_on_opportunity_parameters_and_staff_requirements: "Aucune correspondance basée sur les paramètres d'opportunité et les besoins en personnel, veuillez ajuster votre sélection.",
    no_media: "Le média n'a pas encore été ajouté à ce travail.",
    no_notes_created: "Aucune note n'a encore été créée.",
    no_options_available: "Aucune option disponible",
    no_people_found: "Aucune personne trouvée",
    no_priority: "Aucune priorité",
    no_project_found: "Aucun projet dans les filtres définis",
    no_projects_to_display: "Aucun projets à afficher",
    no_rep_found: "Pas de plan Projet dans les filtres définis",
    no_report_found: "Aucun rapport dans les filtres définis",
    no_reports_available: "Aucun rapport disponible",
    no_reps_to_display: "Aucun représentant à afficher",
    no_response_options: "Il n'y a pas d'options de réponse pour ce type de question.",
    no_response_received: "Aucune réponse du serveur",
    no_responses: "Aucune réponse",
    no_results: "Aucun résultat",
    no_results_found: "Aucun résultat trouvé",
    no_roles: "Aucun rôle",
    no_sales_media_uploaded: "Aucun support de vente n'a été téléchargé",
    no_score_value: "\"Non\" Valeur De Score",
    no_section: "Pas de Rubrique",
    no_selection: "Pas de choix",
    no_sent_announcements: "Aucune annonce envoyée pour le moment",
    no_staff_available_within_the_selected_filters: "Aucun membre du personnel disponible dans les filtres sélectionnés",
    no_store_name: "Pas de nom de magasin",
    no_stores_assigned: "Aucun Magasin Assigné",
    no_submitted_response: "Soumis, aucune réponse",
    no_supervisor_assigned: "Aucun superviseur n'a encore été affecté à cette personne.",
    no_survey_text: "Il n'y a pas encore de questions d'enquête créées pour ce travail.",
    no_tags_found: "Aucune balise trouvée",
    no_tools: "Les outils n'ont pas encore été ajoutés à ce travail.",
    no_value_for: "Aucune valeur pour",
    no_visit_details_found: "Aucun détail de visite trouvé",
    no_work_available: "Aucun travail disponible",
    non_location_specific_question: "Question spécifique à un non-lieu",
    non_staffed_projects: "Projets sans personnel",
    non_standard: "Non standard",
    none: "Rien",
    none_selected: "Aucun sélectionné",
    normal: "Ordinaire",
    normal_priority: "Priorité normale",
    not_clocked_in: "Pas pointé(e) au début",
    not_permitted_in_report: "Vous n'êtes pas autorisé à afficher ce rapport.",
    not_submitted: "Pas transmis",
    not_valid_characters: "ne sont pas des caractères de nom de fichier valides",
    note: "Noter",
    notes: "Remarques",
    nothing_to_select: "Rien à sélectionner",
    nov: "Nov",
    number: "Numéro",
    number_marked_complete: "# marqué comme terminé",
    number_of_locations: "Nombre d'emplacements",
    number_of_occurrence: "Nombre d'occurrences",
    number_of_responses: "Nombre de réponses",
    number_of_visits: "Nombre de visites",
    number_scheduled: "# Programmé",
    number_submitted: "# Soumis",
    numeric: "Numérique",
    occurrence: "occurrence",
    occurrences: "occurrences",
    occurs_every: "se produit tous les",
    occurs_everyday: "Se produit chaque jour",
    oct: "Oct",
    of: "de",
    ok: "d'accord",
    on: "sur",
    on_mplan: "Travail sur un mPlan",
    on_row: "sur la ligne",
    on_this_day: "Ce jour-là",
    on_time: "A l'heure",
    on_track: "Sur la bonne voie",
    on_track_projects: "Projets sur la bonne voie",
    once: "Une fois que",
    once_a_photo_is_removed_it_cannot_be_added_again: "Une fois qu'une photo est supprimée, elle ne peut plus être ajoutée.",
    once_scheduled_only_staff: "Une fois planifié, seul le personnel planifié peut voir ce travail",
    once_the_survey_is_saved_this_action_cannot_be_undone: "Une fois l'enquête enregistrée, cette action ne peut pas être annulée.",
    one_by_movista: "ONE par Movista",
    onehub_by_movista: "1Hub par Movista",
    only_you_can_see_this: "Vous seul verrez le nom de cet événement.",
    ontrack_project_default: "Les projets qui se situent dans le seuil de jour et de pourcentage spécifié et qui devraient être achevés à temps.",
    open: "Ouvrir",
    open_visits: "Visites ouvertes",
    open_visits_tooltip: "Visites ouvertes sont des visites qui ont été programmées mais pas encore soumises.",
    opportunities: "Opportunités",
    opportunities_created: "Opportunités créées",
    opportunities_exist: "Des opportunités existent",
    opportunities_parameters: "Paramètres des opportunités",
    opportunity_parameters: "Paramètres d'opportunité",
    optional: "Optionnel",
    optional_rep_is_automatically_notified_by_email: "Facultatif, le représentant est automatiquement averti par e-mail.",
    options: "Options",
    or: " ou",
    order_information: "Ordre Information",
    original: "Originale",
    original_file_name: "Nom du fichier d'origine",
    other: "Autres",
    out_of: "Hors de",
    outside_agency: "Agence externe",
    outside_start_date_requirement: "En dehors de l'exigence relative à la date de début",
    outside_start_time_requirement: "En dehors de l'exigence d'heure de début",
    overlapping_visits: "Visites qui se chevauchent",
    overlapping_visits_created_review_below: "Visites qui se chevauchent créées. Passez en revue ci-dessous et importez les mises à jour si nécessaire.",
    overlapping_visits_validation_error: "Impossible de planifier la visite en raison d'un chevauchement d'horaires.",
    owner: "Propriétaire",
    page: "Page",
    parent_tag: "Balise parente",
    partial_opportunities_created: "Opportunités partielles créées",
    partial_opportunities_open_visit_tool_tip_begin: "Impossible de générer des opportunités pour",
    partial_opportunities_open_visit_tool_tip_end: "Des visites en fonction des paramètres et des sélections d'exigences du personnel.",
    partial_opportunities_warning: "Les visites ne sont pas basées sur la sélection des paramètres et des exigences.",
    pass_fail_based_percent: "Passe / échec en fonction du pourcentage",
    pass_fail_based_percent_help: "Sélectionnez cette option pour ajouter un pourcentage requis à une enquête de projet notée.",
    pass_fail_email_alert: "Alerte de courrier électronique de réussite / réussite",
    pass_fail_email_alert_help: "Sélectionnez cette option pour envoyer des alertes par e-mail pour chaque soumission d'enquête notée.",
    passed: "Passé",
    passes: "Laissez-passer",
    passing_percentage: "Pourcentage de réussite",
    passing_percentage_error: "Le pourcentage de passage doit être compris entre 1 et 100",
    password: "Mot de passe",
    password_recovery_sentence: "Entrez votre adresse email. Nous vous enverrons par e-mail un lien avec des instructions pour récupérer votre nom d'utilisateur ou votre mot de passe.",
    pause: "Pause",
    paused: "En Pause",
    paused_reason: "Raison mise en pause",
    paused_reason_note: "Note de motif en pause",
    pay: "Payer",
    pay_rate: "Taux de rémunération",
    pay_rate_help: "Entrez le taux de rémunération du personnel du projet en fonction de votre sélection de type de rémunération.",
    pay_rate_in_dollars: "Taux de rémunération (en dollars)",
    pay_type: "Type de paie",
    pay_type_help_flat: "Le personnel est rémunéré sur la base d'un montant fixe pour chaque travail soumis.",
    pay_type_help_hourly: "Rémunération du personnel en fonction des heures travaillées.",
    pay_type_help_none: "Les montants des salaires du personnel ne font pas l'objet d'un suivi.",
    pay_type_help_title: "La sélection du type de rémunération détermine la méthode de rémunération du personnel pour le travail du projet:",
    payroll: "Paie",
    payroll_and_expenses: "Paie et Dépenses",
    pending: "En attente",
    pending_approval: "En Attente de Validation",
    pending_projects: "Projets en attente",
    pending_projects_default: "Les projets qui ont été créés et publiés avec une date dans le futur. Ces projets ne fourniront pas d'état de santé car ils n'ont pas encore commencé.",
    people: "Personnes",
    people_attributes: "Attributs des personnes",
    people_hub: "Centre des personnes",
    percent_marked_complete: "% marqué comme terminé",
    percent_needed_to_pass: "Pourcentage nécessaire pour passer",
    percent_scheduled: "% Programmé",
    percent_submitted: "% Soumis",
    percentage_needed_to_pass: "pourcentage nécessaire pour passer",
    person: "La personne",
    person_unavailable: "personne non disponible",
    personal_info: "Info Personnelles",
    personal_information: "Renseignements Personnels",
    phone_number: "Numéro de téléphone",
    phone_number_error: "Caractère non valide entré. Les caractères valides sont numériques et + x-()",
    phone_numbers: "Numéros de téléphone",
    photo_galleries: "Galeries de Photos",
    photos: "Photos",
    pie: "Diagramme circulaire",
    planning: "Planification",
    planogram_completion: "Achèvement de planogramme",
    planogram_scoring: "Scoring de planogramme",
    platform_availability: "Disponibilité de la plateforme",
    please_add_additional_search_criteria_to_limit_your_search: "Veuillez ajouter des critères de recherche supplémentaires pour limiter votre recherche",
    please_add_one_or_more_response_values: "Ajoutez une ou plusieurs valeurs de réponse.",
    please_address_the_active_question_first: "Veuillez d'abord répondre à la question active.",
    please_adjust_the_filter_set: "Veuillez ajuster le jeu de filtres",
    please_adjust_the_filter_set_or: "Veuillez ajuster le jeu de filtres ou",
    please_adjust_this_filter: "Veuillez ajuster ce filtre.",
    please_assign_a_rep_and_enter_a_start_date_and_time: "affecter un représentant et saisir une date et une heure de début.",
    please_assign_staff_date_and_time: "Veuillez attribuer un personnel, entrez la date et l'heure",
    please_create_report: "Veuillez créer un rapport",
    please_ensure_all_scored_values_are_in_range: "Veuillez vous assurer que toutes les valeurs notées ne se chevauchent pas",
    please_ensure_all_values_are_in_range: "Veuillez vous assurer que toutes les valeurs sont dans la plage.",
    please_enter_correct_url_format: "Veuillez saisir un format d'URL correct contenant \"https://\" ou \"http://\"",
    please_fill_in_the_complete_details_to_confirm: "Veuillez remplir les détails complets pour confirmer.",
    please_provide_an_estimated_time_this_determines_the_duration_of_the_event: "Veuillez fournir une durée estimée. Cela détermine la durée de l'événement.",
    please_remove_all_attributes_in_this_subsection_before_deleting: "Veuillez supprimer tous les attributs de cette sous-section avant de procéder à la suppression.",
    please_select_a_condition_in_conditional_logic: "Veuillez sélectionner une condition dans la logique conditionnelle.",
    please_select_a_value_for: "Veuillez sélectionner une valeur pour",
    please_select_one_visit_row: "Sélectionnez au moins une visite / ligne à inclure",
    please_upload_files_within_uploaded_files: "Veuillez télécharger les fichiers dans l'onglet \"Fichiers téléchargés\"",
    please_upload_media_from_tools_page: "Veuillez télécharger les supports de vente à partir de la page \"Outils\"",
    please_verify_that_any_child_questions: "Veuillez vérifier que toutes les questions enfant ont toujours des réponses dépendantes valides, sinon elles risquent de ne plus apparaître.",
    portal: "Portail",
    postal_code: "Code postal",
    postal_codes: "Codes postaux",
    powered_by_movista: "Propulsé par Movista, Inc.",
    preference_management_tool: "Outil de gestion des préférences",
    preferences: "Préférences",
    preferred: "Préférée",
    preferred_reps: "Représentants préférés",
    preferred_reps_imported: "Répétitions préférées importées",
    preparing_reports: "Préparation des rapports",
    press: "Presse",
    press_the: "appuyez sur la",
    prevent_work_from_being_started: "Empêcher le démarrage des travaux avant l'heure spécifiée",
    prevent_work_from_being_started_after: "Empêcher le démarrage des travaux après l'heure spécifiée",
    previous: "Précédente",
    primary_contact_email: "E-mail de contact",
    primary_contact_name: "Contact principal 1",
    primary_contact_phone: "Numéro de téléphone du contact",
    primary_location: "Emplacement principal",
    primary_rep_locations: "Emplacements des représentants principaux",
    primary_rep_locations_imported: "Emplacements des représentants principaux importés",
    print: "Imprimer",
    prior_next_30_days: "30 jours précédents/suivants",
    prior_year_next_30_days: "Année précédente/30 prochains jours",
    priority: "Priorité",
    priority_help: "Sélectionnez une valeur de priorité à associer à ce travail de projet. Cette entrée est facultative.",
    priority_label: "Priorité",
    privacy_policy: "Politique de confidentialité",
    private: "Privée",
    process_only_open_visits: "traiter UNIQUEMENT les visites ouvertes",
    profile: "Profil",
    project: "Projet",
    project_based: "Basé sur un projet",
    project_count: "Nombre de projets",
    project_date_s: "Date(s) du projet",
    project_dates: "Dates du projet",
    project_drafts: "Projet Brouillons",
    project_due: "Projet dû",
    project_due_date: "Date d'échéance du projet",
    project_due_date_time: "Date et heure d'échéance du projet",
    project_end: "Fin du projet",
    project_end_type_due_date: "DATE D'ÉCHÉANCE : Ce projet se terminera à 00:01 à la date d'échéance sélectionnée.",
    project_end_type_manual: "MANUEL : Ce projet ne se terminera que lorsqu'il aura été sélectionné manuellement pour se terminer.",
    project_end_type_submitted: "100 % SOUMIS : ce projet se terminera une fois que toutes les visites auront été soumises dans l'application.",
    project_id: "ID de Projet",
    project_list: "Liste de projets",
    project_name: "Nom du Projet",
    project_number: "Client Projet #",
    project_number_text: "Projet client",
    project_overview: "Aperçu du projet",
    project_published: "Projet publié",
    project_reference_number: "Numéro de référence du projet",
    project_required_to_be_scheduled: "Si ce projet doit être planifié, le « temps estimé » doit être supérieur à 0 minute.",
    project_start: "Début du projet",
    project_start_date: "Date de début du projet",
    project_start_date_time: "Date et heure de début du projet",
    project_status: "L'état du projet",
    project_template_types: "Types de modèle de projet",
    project_templates: "Projet Modèles",
    project_type: "Type de projet",
    projected_to_be_late: "Prévu pour être en retard",
    projects: "Projets",
    projects_due: "Projets dus",
    projects_due_on: "Projets dus le",
    projects_not_submitted: "projets non soumis",
    projects_selected: "Projets sélectionnés",
    provider_type: "Type de fournisseur",
    province: "Province",
    provinces: "Provinces",
    public: "Publique",
    publish: "Publier",
    publish_changes: "Publier les modifications",
    publish_draft_body: "L'activation d'un projet permet aux personnes utilisant l'application mobile de visualiser le projet. Cette action ne peut pas être annulée.",
    qualified_reps: "Représentants qualifiés",
    qualified_staff_regardless_of_scheduling: "Le personnel qualifié peut voir ce travail indépendamment de la planification",
    qualified_staff_until_scheduled: "Le personnel qualifié ne peut pas voir ce travail tant qu'il n'est pas programmé",
    question_deleted: "Question Supprimée",
    question_duplicated: "Question Dupliquée",
    question_header: "En-tête Question",
    question_header_required: "En-tête de question requis",
    question_s: "Question(s)",
    question_settings: "Paramètres Des Questions",
    question_text: "Texte de la question",
    question_type: "Type De Question",
    quick_select: "Sélection rapide",
    quick_select_locations: "Emplacements à sélection rapide",
    ran_out_of_time: "Non: Ran hors délai",
    range: "Intervalle",
    reactivate_success: "est maintenant actif.",
    reactivate_tag: "Réactiver la balise",
    read_only: "Lecture seule",
    ready: "Prêt",
    reasons: "Justifications",
    recalculate: "Recalculer",
    recalculation_successful: "Recalcul Réussi",
    recently_used: "Récemment utilisé",
    recipient: "Destinataire",
    recipients: "Destinataires",
    recurrence_due: "Récurrence due",
    recurrence_due_date: "Date d'échéance de récurrence",
    recurrence_due_date_help: "La date d'échéance par défaut de la récurrence du projet se termine à 00h01 à la date sélectionnée. Définissez une autre heure d'échéance définie si la dernière heure de début du travail doit être antérieure dans l'application mobile.",
    recurrence_due_date_time: "Date et heure d'échéance de la récurrence",
    recurrence_end: "Fin de la récurrence",
    recurrence_error: "Impossible de récupérer les informations de récurrence. Veuillez réessayer plus tard.",
    recurrence_project_help: "Les projets récurrents ne prennent en charge que le type de fin 'Date d'échéance' ",
    recurrence_start: "Début de la récurrence",
    recurrence_start_date: "Date de début de récurrence",
    recurrence_start_date_help: "L'heure de début par défaut de la récurrence du projet commence à 00:01 à la date sélectionnée. Définissez une autre heure de début définie si le travail doit commencer plus tard dans l'application mobile.",
    recurrence_start_date_time: "Date et heure de début de la récurrence",
    recurring_count_error: "Veuillez saisir le nombre de fois (plus de zéro) que cela se répétera.",
    recurring_end_help: "Sélectionnez quand le projet doit cesser de se reproduire. La valeur par défaut est ne jamais cesser de se reproduire.",
    recurring_events: "Événements récurrents",
    recurs: "Récurrence",
    recurs_indefinitely: "Se répète indéfiniment",
    recurs_until: "Se répète jusqu'à",
    reference_number: "N ° de référence",
    refresh: "Actualiser",
    refresh_data: "Actualiser les données",
    register_a_rep: "Enregistrer Un Représentant",
    register_with_movista: "Activer avec Movista",
    registered_user_subscription_agreement: "Contrat d'abonnement utilisateur enregistré",
    regular: "Ordinaire",
    reissue: "Réémission",
    reissue_cancelled: "Réédition annulée",
    reissue_expiration_date: "Date d'expiration de la réémission",
    reissue_to: "Réédition à",
    reissued: "Réémissioned",
    reissuing_allows_this_visit_to_be_submitted_again_at_this_location: "La réémission permet de soumettre à nouveau cette visite à cet emplacement",
    relative_estimates: "Estimations relatives",
    remaining: "restant",
    remove: "Supprimer",
    remove_acknowledgment: "Supprimer la Reconnaissance",
    remove_attachment: "Supprimer la Pièce Jointe",
    remove_event: "Supprimer un événement",
    remove_from_app_if_marked_complete: "Supprimer de l'application si marqué comme terminé",
    remove_from_app_if_marked_complete_help: "Une fois le travail Infinity soumis et marqué comme terminé dans l’application, le travail sera supprimé de la vue du personnel.",
    remove_from_gallery: "Supprimer de la galerie",
    remove_high_priority: "Supprimer Haute Priorité",
    remove_photos: "Supprimer des photos",
    remove_visit_details: "Supprimer les détails de la visite",
    removed_from_list: "retiré de la liste",
    rep: "Représentant",
    rep_details: "Détails du représentant",
    rep_employee_id: "ID d'employé du représentant",
    rep_has_been_invited: "Représentant A été Invité",
    rep_hub: "Concentrateur de représentation",
    rep_id: "Identifiant du/de la Représentant",
    rep_info: "Infos sur le représentant",
    rep_name: "Nom de la représentation",
    rep_profile: "Profil du représentant",
    rep_readd_end: "Ils auront accès à l'application mobile Movista en fonction de leurs affectations actuelles.",
    rep_readd_middle: "Les informera qu'ils ont été choisis pour travailler",
    rep_readd_start: "Activation",
    rep_reported_miles: "Nombre de Miles signalés",
    rep_type: "Type de représentant",
    rep_types: "Types de représentant(e)",
    repeat: "Répéter",
    repeat_on: "RÉPÉTER SUR",
    report_builder: "Générateur de rapports",
    report_category: "Catégorie de rapport",
    report_deleted: "Rapport supprimé",
    report_details: "Détails du rapport",
    report_name: "Nom du rapport",
    report_shared_successfully: "Rapport partagé avec succès",
    report_template: "Modèle de rapport",
    report_type: "Type de rapport",
    reported_miles_status: "Statut des Miles signalés",
    reporting_center: "Centre de gestion des rapports",
    reporting_values: "Valeurs De Rapport",
    reports: "Rapports",
    reports_ready: "Rapports prêts",
    reps: "Représentants",
    reps_login_question_information: "Les représentants n'ont que des identifiants de connexion numériques. Pour vous connecter au portail, utilisez le même numéro de téléphone et code PIN que vous utilisez pour vous connecter à l'application.",
    reps_not_qualified: "Représentants non qualifiés",
    reps_selected: "Répétitions sélectionnées",
    request_photo: "Demander Des Photos",
    request_setup_failed: "Echec de la configuration de demande",
    request_signature: "Demander Des Signatures",
    require_acknowledgement: "Exiger un accusé de réception",
    require_acknowledgment: "Exiger la Reconnaissance",
    require_this_project_to_be_scheduled: "Exiger que ce projet soit planifié",
    required: "Obligatoire",
    required_upper: "OBLIGATOIRE",
    reschedule: "reporter",
    reschedule_visit: "Reprogrammer la visite",
    reschedule_visits: "reprogrammer les visites",
    resend: "Renvoyer",
    reset: "Réinitialiser",
    reset_filters: "Réinitialiser les filtres",
    reset_filters_to_default: "Réinitialiser les filtres par défaut.",
    reset_to_default: "Dréinitialiser les filtres par défaut",
    response: "Réponse",
    response_options: "Options De Réponse",
    response_points: "Points De Réponse",
    response_summary: "Texte de la question de suivi-Raisons du planogramme Non rempli",
    response_type: "Type de réponse",
    response_type_help: "Sélectionnez le type de réponse que vous prévoyez d'utiliser pour vos questions d'enquête.Choisissez la norme si vous ne prévoyez pas d'appliquer des scores à vos questions.",
    response_values: "Valeurs De Réponse",
    response_visibility: "Visibilité de la réponse",
    response_visibility_help: "L'activation de cette fonctionnalité définira le projet sur Privé, afin que les utilisateurs de l'application ne puissent pas voir les réponses laissées par d'autres dans l'application mobile.",
    result: "Résultat",
    result_too_large: "Le nombre de résultats est trop important. Veuillez ajuster ou",
    result_too_large_adjust: "Le nombre de résultats est trop élevé. Veuillez ajuster les filtres.",
    results: "Résultats",
    retail_details: "Détails de détail",
    retailer: "Détaillant",
    retailer_name: "Nom du détaillant",
    retailers: "Détaillants",
    retry: "Retenter",
    retry_sending: "Réessayer l'envoi",
    review: "Passer en revue",
    review_warnings_below_and_import_updates_if_needed: "Consultez les avertissements ci-dessous et importez les mises à jour si nécessaire.",
    role__s: "Les rôles)",
    roles: "Rôles",
    roles_assigned: "Rôles Affectés",
    role_assignments: "Attributions de rôles",
    route_drive_time_minutes: "Durée de l'unité de route (minutes)",
    route_mileage_tracking: "Utiliser le suivi du kilométrage de l'itinéraire",
    route_mileage_tracking_help: "Gérez si les itinéraires du personnel sont surveillés lors des déplacements vers chaque lieu de travail. Si cette option est activée, les itinéraires de conduite réels du personnel sont comparés à l'itinéraire de conduite idéal. Par défaut, le suivi du kilométrage de l'itinéraire est activé.",
    route_miles: "Maire de route",
    route_rep_reported_variance: "Ecart signalé Route / Rep",
    routing_and_mileage_comparison: "Comparaison d'itinéraire et de kilométrage",
    row: "Ligne",
    run: "Exécuter",
    run_dashboard: "Exécuter le tableau de bord",
    run_report: "Exécuter Rapport",
    running: "Fonctionnement",
    running_behind: "Courir derrière",
    running_behind_project_default: "Les projets qui sont en retard sur le seuil de jour et de pourcentage spécifié et peuvent avoir un certain risque d'être terminés à temps.",
    running_behind_projects: "Courir derrière les projets",
    saturday: "Samedi",
    save: "Enregistrer",
    save_and_continue: "Save & Continuer",
    save_as: "Enregistrer sous",
    save_as_draft: "Enregistrer comme Brouillon",
    save_as_pdf: "Enregistrer en tant que PDF",
    save_assignment: "Enregistrer l'affectation",
    save_assignments: "Enregistrer les affectations",
    save_changes: "Sauvegarder les modifications",
    save_disabled: "Enregistrer désactivé, pas de crochets angulaires.",
    save_draft: "Enregistrer le brouillon",
    save_print: "Enregistrer/Imprimer",
    save_selections: "Enregistrer les sélections",
    save_successful: "Sauver succès",
    save_survey: "Enregistrer L'enquête",
    scatter: "Dispersion",
    schedule: "Emploi du temps",
    schedule_and_assign: "Planifier et attribuer",
    schedule_date: "Date de planification",
    schedule_date_time: "Date / heure du planning",
    schedule_overview: "Aperçu de l'horaire",
    schedule_status: "Statut de la planification",
    schedule_this_visit: "Programmez cette visite",
    schedule_time: "Horaire",
    schedule_visit: "Planifier une visite",
    scheduled: "Programmé",
    scheduled_date: "Date planifiée",
    scheduled_rep: "Représentation planifiée",
    scheduled_rep_time_manager: "Gestionnaire de temps de représentation planifiée",
    scheduled_rep_type: "Type de représentation planifiée",
    scheduled_time: "Heure prévue",
    scheduled_visit: "Visite programmée",
    scheduled_visits: "Visites programmées",
    scheduled_visits_tooltip: "Visites planifiées sont des visites qui ont été programmées et soumises.",
    scheduling: "Programmation",
    scheduling_config: "Configuration de la planification",
    scheduling_details: "Détails de planification",
    scheduling_in_est: "Planification en EST",
    scheduling_permissions: "Autorisations de planification",
    scheduling_permissions_help: "Gérez qui est autorisé à planifier le travail. Gérez également quand le personnel peut voir le travail planifié dans l'application.",
    scheduling_times_in: "Heures de planification en",
    scheduling_visibility: "Visibilité de la planification",
    score_only: "Score uniquement",
    score_only_help: "Masquer les résultats détaillés de ShelfCheck",
    score_percentage: "Pourcentage de Score",
    score_ranges: "Plage De Score",
    score_status: "État du Score",
    scored: "Marqué",
    scored_question_label: "Étiquette Dde Question Notée",
    scored_response_type_details: "Détails de type de réponse scores",
    search: "Chercher",
    search_alert_circle_icon: "icône de cercle d'alerte de recherche",
    search_assigner: "Rechercher un cédant",
    search_attributes: "Attribut De Recherche",
    search_city: "Rechercher la ville",
    search_clients: "Rechercher des clients",
    search_close_icon: "Rechercher l'icône Fermer",
    search_columns: "Chercher Colonnes",
    search_current_location: "Rechercher l'emplacement actuel",
    search_email: "Rechercher un e-mail",
    search_employee_id: "Rechercher les identifiants des employés",
    search_for_galleries_error: "Veuillez saisir 3 caractères ou plus pour rechercher des galeries",
    search_for_people: "Recherche de personnes",
    search_for_staff: "Rechercher du personnel",
    search_for_work: "Rechercher du travail",
    search_item_sets: "Rechercher des ensembles d'éléments",
    search_items: "Requêtes d'article de recherche",
    search_last_active: "Rechercher le dernier actif",
    search_last_project_activity: "Rechercher la dernière activité du projet",
    search_managers: "Gestionnaires de recherche",
    search_messages: "Rechercher des messages",
    search_mobile_phone: "Rechercher un numéro de téléphone",
    search_more_filters: "Rechercher plus de filtres",
    search_name: "Rechercher des noms",
    search_open_icon: "Icône d'ouverture de recherche",
    search_project_names: "Rechercher des noms de projet",
    search_projects: "Rechercher Des Projets",
    search_rep_names: "Rechercher des noms de représentant",
    search_rep_types: "Rechercher des types de représentants",
    search_results: "Résultats de la recherche",
    search_retailers: "Rechercher des détaillants",
    search_roles: "Rechercher des rôles",
    search_staff: "Personnel de recherche",
    search_state: "Recherche d'état",
    search_status: "Recherche de statut",
    search_supervisor: "Rechercher les superviseur",
    search_supervisors: "Rechercher les superviseur(s)",
    search_tags: "Rechercher des balises",
    search_time_manager: "Rechercher un gestionnaire de temps",
    search_timezone: "Rechercher le fuseau horaire",
    search_zero: "Votre recherche a donné 0 résultat",
    second: "deuxième",
    secondary_contact_email: "E-mail de contact",
    secondary_contact_name: "Contact principal 2",
    secondary_contact_phone: "Numéro de téléphone du contact",
    seconds: "seconds",
    section: "Section",
    section_details: "Détails de la section",
    section_name: "Nom de la section",
    sections: "Sections",
    select_a_question: "Sélectionnez une question",
    select_a_response_option: "Sélectionnez une option de réponse",
    select_a_scene: "Sélectionnez une scène",
    select_a_sub_scene: "Sélectionnez une sous-scène",
    select_a_tool: "Sélectionnez un outil",
    select_all: "Tout sélectionner",
    select_all_that_apply: "Sélectionnez tout ce qui s'y rapporte",
    select_date_range: "Sélectionner une plage de dates",
    select_individual_unqualified_reps: "Sélectionnez des représentants individuels non qualifiés",
    select_item_requests_to_add: "Sélectionnez les demandes d'éléments que vous souhaitez ajouter à ce travail.",
    select_item_sets_to_add_to_this_project: "Sélectionnez l'ensemble d'éléments que vous souhaitez appliquer à la question.",
    select_list_to_delete: "Sélectionnez une liste",
    select_location: "Sélectionnez l'emplacement",
    select_location_lists: "Sélection des listes d'emplacements",
    select_locations_report: "Sélectionnez les emplacements à inclure dans ce rapport.",
    select_opportunity_create_date_export: "Sélectionner la ou les Date (s) de création d'opportunité à exporter",
    select_parameters: "Sélectionnez les paramètres",
    select_recipients: "Sélectionnez les destinataires",
    select_reps_to_decommission: "Sélectionnez les représentants à déclasser",
    select_staff: "Sélectionnez le personnel",
    select_staff_projects: "Sélectionner le personnel et le projet",
    select_staff_requirements: "Sélectionnez les exigences du personnel",
    select_which_days_should_also_have_this_schedule: "Sélectionnez les jours qui devraient également avoir cet horaire",
    selected: "Choisie",
    selected_parameters: "Paramètres sélectionnés",
    selections_saved: "Sélections enregistrées",
    send_alert_mobile: "Envoyer une alerte si un utilisateur mobile",
    send_connection_request: "Envoyer une demande de connexion",
    send_email: "Envoyer un courriel",
    send_escalation_alert_to: "Envoyer une alerte d'escalade à",
    send_exchange_request: "Envoyer une demande d'échange",
    send_invitation: "Inviter",
    send_request: "Envoyer la demande",
    sending_response_email: "Vous envoyez un e-mail contenant les réponses soumises à",
    sent: "Expédié",
    sep: "Sept",
    set_a_due_time: "Définir une date limite pour ce projet",
    set_activated: "Activation réussie",
    set_create_success: "La création de l'ensemble d'articles a abouti",
    set_deactivated: "Désactiver le succès",
    set_start_time_for_project: "Définir une heure de début pour ce projet",
    set_updated: "Ensemble mis à jour",
    settings_title: "Réglages",
    share: "Partager",
    share_link: "Lien de partage",
    share_type: "Type de partage",
    share_update_tooltip: "Lorsque cette option est sélectionnée, les destinataires peuvent cliquer sur Actualiser pour obtenir les données du rapport les plus récentes. Les données seront actualisées pour tous les destinataires. Si les destinataires ne peuvent pas actualiser les données du rapport, ils ont uniquement accès à un instantané statique du rapport à partir de la date et de l'heure auxquelles vous l'avez partagé.",
    shared_by: "Partagé par",
    shared_with: "Partagé avec",
    shelf_check_warning: "Les questions ShelfCheck ne prennent en charge que le type de réponse'Sélection unique'",
    shipment_description: "Description de l'envoi",
    shipped_to: "Expédiés à",
    shipping_address: "Adresse de livraison",
    shipping_and_primary_location: "Expédition et Emplacement Principal",
    show_historical_responses: "Afficher Les Réponses Historiques",
    show_infinity: "Afficher l'infini",
    show_insights: "Afficher les statistiques",
    show_no_response: "Afficher aucune réponse",
    show_no_responses: "Afficher aucune réponse",
    show_qualified_staff_only: "Afficher uniquement le personnel qualifié",
    show_this_question_if_response_to: "Afficher cette question si la réponse à",
    showing_truncated: " résultats au total. Affichage maximum ",
    shown: "Montré",
    similar_client_title: "Client existant possible",
    similar_entry_title: "Valeur existante possible",
    similar_entry_tooltip: "Valeurs existantes avec un texte similaire",
    single_select: "Sélection Unique",
    single_sign_on_allows_you_to_log_in: "L'authentification unique vous permet de vous connecter à l'aide du fournisseur d'identité de votre organisation.",
    skills_and_capabilities: "Compétences et capacités",
    skills_capabilities: "Compétences et capacités",
    some_time: "Besoin de temps pour y réfléchir ?",
    sort: "Trier",
    special_characters: "Caractères spéciaux:",
    staff: "Personnel",
    staff_activity: "Activité du personnel",
    staff_and_manager: "Personnel et gérant",
    staff_based: "Basé sur le personnel",
    staff_email: "Courriel du personnel",
    staff_hierarchy: "Hiérarchie du personnel",
    staff_id: "Identifiant Personnel",
    staff_name: "Nom du personnel",
    staff_not_qualified_for_this_visit: "personnel non qualifié pour cette visite",
    staff_phone_number: "Numéro de téléphone du personnel",
    staff_requirements: "Besoins en personnel",
    staff_selected: "Personnel sélectionné",
    staff_type: "Type de personnel",
    staff_types: "Types de personnel",
    staff_with_opportunity: "Personnel avec opportunité",
    staff_without_opportunity: "Personnel sans opportunité",
    staffed: "Doté",
    staffed_projects: "Projets dotés en personnel",
    staffed_projects_tooltip: "Créez des alertes d'escalade de visite à envoyer en fonction de tout membre du personnel affecté aux visites de projet.",
    staffed_projects_tooltip_second_text: "Les visites doivent être assignées et une hiérarchie de superviseurs correctement en place.",
    standard: "la norme",
    standard_attributes: "Attributs standards",
    standard_hours: "Heures normales",
    start: "Démarrer",
    start_date: "Date de début",
    start_date_explanation: "Utiliser la date de début du projet",
    start_date_help: "L'heure de début par défaut du projet commence à 00:01 à la date sélectionnée. Définissez une autre heure de début définie si le travail doit commencer plus tard dans l'application mobile.",
    start_date_time: "Date / heure de début",
    start_dates: "Date(s) de début",
    start_due_error: "La date de début doit être antérieure à la date d'échéance.",
    start_due_time_error: "L'heure de début ne peut pas être identique ou ultérieure à l'heure d'échéance.",
    start_is_required: "La date de début est requise.",
    start_message: "Message de démarrage",
    start_time: "Heure de début",
    start_time_is_required: "La date de début est requise",
    start_typing_to_see_results: "Démarrer la saisie pour afficher les résultats",
    started: "A débuté",
    state: "Etat",
    state_province: "Etat/Province",
    states: "États",
    status: "Statut",
    status_code: "Code de statut",
    status_legend: "Légende du statut",
    status_overview_chart_title: "Aperçu de l'état",
    status_updated: "Statut mis à jour",
    stop_recurring: "Arrêter de se reproduire",
    store: "Magasin",
    store_details: "Détails du Magasin",
    store_name: "Nom du magasin",
    store_names: "Noms des magasins",
    store_number: "Numéro de magasin",
    store_number_hash: "Magasin #",
    store_numbers: "Numéros de magasin",
    store_time: "Temps de Magasin",
    stores: "Magasins",
    stores__default: "Emplacements (A - Z)",
    stores__number: "Emplacements (#)",
    stores__zip: "Codes Postaux",
    street_1: "Rue 1",
    street_2: "Rue 2",
    sub_sections: "sous-sections",
    submission_date: "Date de soumission",
    submission_details: "Détails de la soumission",
    submission_overview: "Aperçu de la soumission",
    submission_source: "Source de soumission",
    submission_status: "État de la soumission",
    submission_time: "Heure de soumission",
    submit: "Soumettre",
    submitted: "Soumis",
    submitted_date: "Date de Soumission",
    submitted_end_date: "Date de fin de soumission",
    submitted_end_time: "Heure de fin de soumission",
    submitted_no_answers: "Aucune réponse soumise",
    submitted_on: "Soumis le",
    submitted_projects: "Projets soumis",
    submitted_rep: "Représentant soumis",
    submitted_rep_time_manager: "Gestionnaire de temps de représentant soumis",
    submitted_rep_type: "Type de représentant soumis",
    submitted_staff: "Personnel soumis",
    submitted_time: "Heure de Soumission",
    submitted_without_responses: "Soumis sans réponses",
    success_invitation_details_have_been_sent: "Succès - Les détails de l'invitation ont été envoyés.",
    success_invitation_details_have_been_sent_to: "Succès - Les détails de l'invitation ont été envoyés à: ",
    successfully_confirmed: "Confirmé avec succès",
    successfully_copied_all: "Tout dupliqué avec succès",
    successfully_created: "Créé avec succès",
    successfully_deleted: "Supprimé Avec Succès",
    successfully_imported_list: "Liste importée avec succès",
    successfully_published_changes: "Modifications Publiées Avec Succès",
    successfully_updated: "Mise à jour réussie",
    summary: "Résumé",
    sunday: "Dimanche",
    supervisor: "Superviseur",
    supervisors: "Superviseur(s)",
    supplier: "Fournisseur",
    support: "Soutien",
    supports_diff_image_types: "Prise en charge : JPG, PNG, JPEG",
    supports_diff_media_types: "Prend en charge : BMP, CSV, DOC, DOCX, GIF, HTM, HTML, JPG, JPEG, MOV, MP3, MP4, PNG, PDF, PPT, PPTX, RTF, TXT, WAV, WMV, XLS, XLSX, & ZIP",
    survey_builder_conditional_logic_info: "L'ajout de la logique d'affichage déplacera la question actuelle sous la question parent sélectionnée dans la liste des questions.",
    survey_builder_conditional_tag_info: "Si la question parent a des étiquettes, elles seront également ajoutées à cette question.",
    survey_builder_unsaved_changes: "Vous avez des changements non enregistrés. Êtes-vous sûr de vouloir continuer?",
    survey_date: "Date d'enquête",
    survey_isq_sub_header: "Ajoutez un ensemble d'articles pour obtenir des réponses spécifiques à cette question.",
    survey_isq_tool_tip: "Lorsqu'un ensemble d'articles est ajouté à une question, le représentant peut répondre séparément à la question pour chaque élément de l'ensemble. Les éléments ne seront affichés que dans les emplacements pour lesquels ils sont autorisés.",
    survey_lsq_sub_header: "Si aucune liste d'emplacements n'est sélectionnée, la question sera affichée à tous les emplacements.",
    survey_lsq_tool_tip: "Lorsqu'une question est spécifique à l'emplacement, elle ne s'affiche qu'à l'utilisateur mobile lorsqu'elle répond à cette enquête à l'un des emplacements sélectionnés.",
    survey_not_found: "Enquête introuvable",
    survey_title: "Questions de l'enquête",
    tag_manager: "Gestionnaire de balises",
    tag_mvid: "Jour MVID",
    tag_name: "Nom de la balise",
    tag_status_updated: "Statut de balise mis à jour",
    tag_type: "Type de balise",
    tags: "Mots clés",
    template_name: "Nom du modèle",
    template_type: "Type de modèle",
    template_type_help_1: "Sélectionnez parmi les types de modèles existants pour ajouter une étiquette d'attribut qui améliore l'organisation de n'importe quel modèle de projet.",
    template_type_help_2: "Les types de modèles sont créés et gérés dans les paramètres d'administration.",
    templates: "Modèles",
    terms_of_use: "Conditions d'utilisation",
    text: "Texte",
    text_entry: "Saisie de texte",
    the_selected_filters: "les filtres sélectionnés",
    the_submitted_rep: "Le représentant soumis",
    there_are_no_assignments_set_for_this_project: "Aucun devoir n'est défini pour ce projet",
    there_are_no_attributes_assigned: "Il n'y a pas d'attributs attribués à ce membre du personnel",
    there_are_no_item_requests_selected_for_this_project: "Aucune demande d'article n'a été sélectionnée pour ce projet.",
    there_are_no_opportunities: "Aucune opportunité n'a été créée pour ce projet.",
    third: "troisième",
    this_action_cannot_be_undone: "Cette action ne peut pas être annulée.",
    this_action_will_undo_all_unsaved_changes_to_the_survey_this_action_cannot_be_undone: "Cette action annulera toutes les modifications non enregistrées apportées à l'enquête. Cette action ne peut pas être annulée.",
    this_deletes_it_for_everyone_and_cannot_be_undone_it_can_not_be_restored: "Cela supprime pour tout le monde et ne peut pas être annulé. Ça ne peut pas être défait",
    this_feedback_is_seen_by_reps: "Ce retour est vu par les commerciaux",
    this_field_is_required: "Ce champ est requis",
    this_mplan_cannot_be_reissued_at_this_location: "Ce mPlan ne peut pas être réémis à cet endroit",
    this_mplan_was_not_submitted_by_any_rep: "Ce mPlan n'a été soumis par aucun représentant",
    this_mplan_was_submitted_by: "Ce mPlan a été soumis par",
    this_person_is_missing_required_skills_and_capabilities: "Cette personne n'a pas les compétences et les capacités requises",
    this_question_must_contain_text: "Cette question doit contenir du texte.",
    this_question_only: "Cette question seulement",
    this_report_contains_too_many_results_delete_it: "Ce rapport contient trop de résultats. Veuillez supprimer ce rapport de la ",
    this_section_cannot_be_deleted_please_remove_all_attributes_in_this_section_before_deleting: "Cette section ne peut pas être supprimée. Veuillez supprimer tous les attributs de cette section avant de supprimer",
    this_visit_cannot_be_scheduled_after_the_latest_available_date_of: "Cette visite ne peut être programmée après la dernière date disponible de",
    this_visit_cannot_be_scheduled_prior_to_the_current_date_time: "Cette visite ne peut pas être programmée avant la date/heure actuelle",
    this_visit_cannot_be_scheduled_prior_to_the_earliest_available_date_of: "Cette visite ne peut pas être programmée avant la première date disponible de",
    this_visit_overlaps_with_an_existing_event: "Cette visite chevauche un événement existant",
    this_visit_overlaps_with_another_event: "La visite coïncide avec un autre événement",
    this_will_auto_populate: "Cela remplira automatiquement la réponse précédente et remplacera toutes les réponses \"par défaut\"",
    threshold_settings: "Paramètres de seuil",
    thursday: "Jeudi",
    ticket_id: "ID de billets",
    time: "Temps",
    time_elapsed: "Temps écoulé",
    time_management: "Gestion du temps",
    time_manager: "Gestionnaire de Temps",
    time_submitted: "Heure de soumission",
    timeframe: "Plage de temps",
    times_shown_in: "Heures affichées en",
    timezone: "Fuseau horaire",
    timezones: "Fuseaux horaires",
    title_is_required: "Le titre est requis",
    to: "à",
    to_be_scheduled: "être programmé",
    to_continue: "continuer",
    to_create_a_new_upload_set: "pour créer un nouveau jeu de téléchargement",
    to_create_an_item_request: "pour créer une demande d'article.",
    to_give_you_the_best_experience: "Pour vous offrir la meilleure expérience",
    to_include_instructions: "inclure des instructions.",
    to_include_media: "bouton pour joindre un média à ce projet.",
    to_include_tools: "bouton pour attacher des outils à ce projet.",
    to_populate_data: "pour remplir les données.",
    to_select_any_item_requests: "pour sélectionner les demandes d'articles.",
    today: "aujourd'hui",
    tomorrow: "Demain",
    too_many_reps_selected_500_max: "Trop de représentants sélectionnés. 500 max",
    too_many_results: "Trop de résultats",
    too_many_results_within: "Trop de résultats dans",
    too_many_staff_results_within_the_selected_filters: "Trop de résultats de personnel dans les filtres sélectionné",
    took_break: "Casser les jouets",
    tool_assigned: "Outil attribué : non autorisé à afficher",
    tool_items_added_to_project: "Outil(s) ajouté(s) au projet",
    tool_name: "Nom de l'outil",
    tools: "Outils",
    tools_title: "Outils",
    total_device_mileage: "Kilométrage total des unités",
    total_projects_completed: "Total des projets terminés",
    total_route_mileage: "Kilométrage total des routes",
    total_store_visits: "Visites totales en magasin",
    total_time_at_location: "Temps total sur place",
    total_time_at_locations_hours: "Temps total sur place (heures)",
    total_time_on_clock_by_day: "Temps total sur l'horloge par jour",
    total_time_on_clock_hours: "Temps total sur l'horloge (heures)",
    total_time_on_project: "Temps total sur le projet",
    total_time_on_project_hours: "Temps total sur le projet (heures)",
    total_visits_processed: "Nombre total de visites traitées",
    tracking_numbers: "Numéros de suivi)",
    tuesday: "Mardi",
    twelve_hours: "12 heures",
    twenty_four_hours: "24 heures",
    type: "Taper",
    type_enter_search: "Tapez pour rechercher, Enter pour sélectionner",
    type_message: "Tapez un message",
    unable_complete_scheduling_error_message: "Impossible de terminer la demande. Vérifiez que tous les paramètres de planification sont valides.",
    unable_retrieve_tags_save_and_refresh: "Impossible d'extraire les étiquettes. Veuillez enregistrer votre progression, puis réactualiser la page pour réessayer.",
    unable_to_create_gallery_required_fields: "Nous ne pouvons pas créer votre Galerie en raison des champs obligatoires manquants suivants",
    unable_to_delete_section: "Impossible de supprimer la section",
    unable_to_schedule_visit_error_message_manage_permission: "Impossible de planifier cette visite car l'utilisateur ne dispose pas de l'autorisation de planification/gestion",
    unable_to_schedule_visit_to_unqualified_rep: "Impossible de planifier cette visite à un représentant non qualifié",
    unable_to_unassign_visit_error_message: "Impossible d'annuler l'attribution de cette visite car MVID est nul",
    unable_to_unassign_visit_error_message_manage_permission: "Impossible d'annuler l'attribution de cette visite car l'utilisateur ne dispose pas de l'autorisation de planification/gestion",
    unassign: "Désattribuer",
    unassign_visit: "Désattribuer la visite",
    uncategorized: "Non classé",
    undefined: "Indéfini",
    undo: "Annuler",
    undo_changes: "Annuler les changements",
    unit_of_measure: "km",
    unit_of_measurement: "Unité de mesure",
    united_states: "Les États-Unis",
    unknown: "Inconnue",
    unknown_contact: "Contact inconnu",
    unknown_mplan: "mPlan Inconnu",
    unsaved_changes_warning: "Vous avez des changements non enregistrés. Êtes-vous sûr de vouloir continuer?",
    unscheduled_visits: "Visites non planifiées",
    unselect_all: "Tout déselectionner",
    unstaffed_projects: "Projets sans personnel",
    unstaffed_projects_tooltip: "Créez des alertes d'escalade de visite à envoyer aux rôles affectés au projet.",
    unsupported_file_type: "Type de fichier non pris en charge",
    upcoming: "A venir",
    update: "Mise à jour",
    update_attachment: "Mettre à jour la pièce jointe",
    update_custom_field: "Mettre à jour la zone personnalisée",
    update_global_attributes: "Mettre à jour les attributs globaux",
    update_list: "Liste mise à jour",
    update_location_availability: "Mettre à jour la disponibilité de l'emplacement",
    update_location_specific_attributes: "Mettre à jour les attributs spécifiques de l'emplacement",
    update_set: "Mise à jour d'un ensemble",
    update_set_name: "Mettre à jour l'ensemble d'articles",
    update_survey: "Mettre à jour l'enquête",
    upload_a_file: "Télécharger un fichier",
    upload_csv: "Importer un fichier CSV",
    upload_files: "Télécharger des fichiers",
    upload_new_image: " Télécharger une nouvelle image",
    upload_opt_in_contract: "Télécharger l'opt dans le contrat",
    upload_or_drop_pdf: "Téléchargez ou déposez votre PDF ci-dessous",
    upload_picture: "Fichier à télécharger",
    upload_values: "Valeurs de Téléchargement",
    use_complete_confirmation: "Utiliser la confirmation complète",
    use_default_mvid: "Utiliser le MVID par défaut",
    use_for_assignments: "Utiliser Pour Les Devoirs",
    use_legacy_view: "Utiliser l'affichage hérité",
    use_sso: "Utiliser l'authentification unique",
    use_work_approval: "Utiliser l'approbation des travaux",
    use_work_escalation_alerts: "Utiliser les alertes d'escalade de travail",
    user_action: "Action de l'utilisateur",
    user_details: "Détails de l'utilisateur",
    user_facing: "Face à l'utilisateur",
    user_group_s: "Groupe (s) d'utilisateurs",
    usergroups: "Groupes d'utilisateurs",
    username: "Nom d'utilisateur",
    username_and_password_recovery: "Récupération du nom d'utilisateur et du mot de passe",
    username_or_password_is_incorrect: "L'identifiant ou le mot de passe est incorrect.",
    users: "Utilisateurs",
    valid_phone_number: "S'il vous plaît entrer un numéro de téléphone valide.",
    validating_file_data: "Validation des données du fichier...",
    value_can_not_have_more_decimals_than_selected: "La valeur ne peut pas avoir plus de décimales que celle sélectionnée.",
    values: "Valeurs",
    values_selected: "Valeur(s) sélectionnée(s)",
    vendor: "Vendeur",
    vendor_dsd: "Fournisseur-DSD",
    vendor_non_dsd: "Fournisseur-Non DSD",
    vendors: "Fournisseurs",
    verify_contract_continue: "Vérification du contrat à poursuivre",
    view: "Voir",
    view_assignment_summary: "Afficher le résumé de l'affectation",
    view_attachment: "Voir la pièce jointe",
    view_details: "Afficher les détails",
    view_edit_visit_details: "Afficher/Modifier les détails de la visite",
    view_full_size: "Afficher en taille réelle",
    view_images: "Voir Les Photos",
    view_less: "Afficher moins",
    view_locations: "Afficher Les Emplacements",
    view_more: "Voir plus",
    view_opportunities: "Voir les opportunités",
    view_rep_del: "Afficher, remplacer ou supprimer une pièce jointe",
    view_responses: "Afficher les réponses",
    view_survey: "Voir l'enquête",
    view_tag_usage: "Afficher l'utilisation des balises",
    visit_activity: "Activité de visite",
    visit_details: "Détails de la Visite",
    visit_details_deleted: "Détails de la visite supprimés",
    visit_id: "ID de Visite",
    visit_reissued: "Visitez Réédité",
    visit_selection: "Sélection de la visite",
    visit_status: "Statut de la visite",
    visit_successfully_scheduled: "Visite (s) prévue (s)",
    visits_detailed: "Visites détaillées",
    visits_w_opportunities: "Visites avec opportunités",
    visits_w_opportunities_tooltip: "Visites avec opportunités sont des visites qui ont été programmées et soumises.",
    visits_with_opportunity: "Visites avec opportunité",
    visualize_data: "Visualiser les données",
    visualized_data: "Données visualisées",
    waiting_approval: "Approbation en attente",
    warnings: "Avertissements",
    wednesday: "Mercredi",
    week: "semaine",
    week_capitalized: "Semaine",
    week_plural: "Semaines)",
    week_range_feedback: "Doit être compris entre 0 et 168",
    weekly: "Hebdomadaire",
    weekly_blank_error: "Le nombre est requis pour chaque semaine.",
    weekly_recurring_end_error: "semaine(s).",
    weekly_recurring_start_error: "Cette récurrence ne peut pas durer plus de",
    weeks: "semaines",
    welcome: "Bienvenue",
    welcome_to_the_new_preference_management_tool: "Bienvenue dans le nouvel outil de gestion des préférences. Ici vous pourrez facilement et facilement basculer sur toutes les fonctionnalités d'Athena. Il s'agit d'un travail en cours qui deviendra de plus en plus robuste au fil du temps.",
    what_is_the_latest_date: "Quelle est la dernière date à laquelle ce projet est disponible pour démarrer ?",
    what_is_the_latest_date_time: "Quelle est la dernière date et heure à laquelle ce projet est disponible pour démarrer ?",
    when_should_this_project_become_available: "Quand ce projet devrait-il être disponible pour démarrer dans l'application mobile?",
    which_login_should_i_use: "Quelle connexion dois-je utiliser?",
    which_question: "Quelle Question",
    who_share_report_with: "Avec qui voulez-vous partager ce rapport?",
    whole_number: "Nombre Entier",
    work: "Travail",
    work_approval: "Approbation des travaux",
    work_approval_help: "Gérez si les soumissions de travail nécessitent l'approbation de l'administrateur dans Détails de la visite Work Hub avant que la soumission ne soit finalisée. Par défaut, Utiliser l'approbation de travail est désactivé.",
    work_escalation: "Escalade de travail",
    work_escalation_alerts_help: "Est « en retard » ou « risque d'être en retard ». Cette fonction ne peut pas être utilisée avec l'infini.",
    work_escalation_alerts_not_available_for_infinity_projects: "Alertes d'escalade de travail non disponibles pour les projets infinity",
    work_escalation_configurations: "Configurations d'escalade de travail",
    work_hub: "Hub de Travail",
    work_log: "Carnet d'activité",
    work_log_date: "Date du journal des travaux",
    work_type: "Type de projet",
    work_type_help: "Sélectionnez le type de projet MPLAN dont vous avez besoin.Sélectionnez «Standard» si vous prévoyez de définir le nombre de fois que le personnel terminera les travaux dans ce projet.Sélectionnez «Infinity» si vous avez besoin d'un nombre indéfini de soumissions de travail pour ce projet.",
    would_you_like_to_limit_to_most_recent_by_location: "Voulez-vous limiter les résultats à la soumission la plus récente par emplacement?",
    would_you_like_to_save_these_selections_as_a_list: "Souhaitez-vous enregistrer ces sélections sous forme de liste?",
    year: "année",
    yearly: "Annuel",
    years: "années",
    yes: "Oui",
    yes_display_text: "Texte de l'option de réponse-Planogramme terminé",
    yes_no: "Oui / Non",
    yes_score_value: "\"Oui\" Valeur De Score",
    yesterday: "Hier",
    you_added_the_max_number_alerts_5: "Nombre maximum d'alertes ajoutées.",
    you_are_about_to_cancel_a_reissued_visit: "Vous êtes sur le point d'annuler une visite rééditée",
    you_are_about_to_decline: "Vous êtes sur le point de refuser cette opportunité pour ",
    you_are_about_to_delete_master_questions_from_this_survey: "Vous êtes sur le point de supprimer les questions maîtresses de cette enquête",
    you_are_about_to_delete_this_parent_question: "Vous êtes sur le point de supprimer cette question parente",
    you_are_about_to_delete_this_question: "Vous êtes sur le point de supprimer cette question",
    you_are_scheduling_this_over_an_unavailability_window: "Vous planifiez cela sur une fenêtre d'indisponibilité",
    you_have_edited_a_parent_question: "Vous avez modifié une question parent",
    you_have_selected: "Vous avez sélectionné",
    you_must_enter_value: "Vous devez entrer une valeur.",
    you_must_narrow_down_your_selected_locations_to_continue: "Vous devez affiner vos emplacements sélectionnés pour continuer.",
    you_must_select_at_least_one_day: "Vous devez sélectionner au moins un jour.",
    you_must_set_assignments_and_visits_to_create_opportunities: "Vous devez définir « Affectations et visites » pour créer des opportunités.",
    youll_need_to_add_filters_to_find_the_places_youre_looking_for: "vous devrez ajouter des filtres pour trouver les lieux que vous recherchez",
    youll_need_to_apply_filters_to_find_the_items_youre_looking_for: "vous devrez appliquer des filtres pour trouver les éléments que vous recherchez",
    your_ranges_are_overlapping: "Vos plages se chevauchent",
    your_search_returned_too_many_records: "Votre recherche a renvoyé trop d'enregistrements",
    zip: "Code postal",
    zip_code: "Code postal",
    zip_codes: "Codes zip",
    upload_objects: "Télécharger la liste",
    added_objects: "Objets ajoutés",
    object_lookup: "Liste de recherche",
    object_lookup_template: "Modèle de liste de recherche",
    this_question_requires_objects_lookup: "Cette question nécessite qu'une liste de recherche soit jointe.",
    object_lookup_error: "Erreur lors du téléchargement du modèle de liste de recherche.",
    view_objects: "Afficher la liste",
    file: "fichier",
    title: "Titre",
    model_type: "Type de modèle",
    active_date: "Date d'activation",
    expiration_date: "Date d'expiration",
    planogram_manager: "Gestionnaire de planogramme",
    bulk_import_planogram: "Importation groupée de planogrammes",
    planogram_invalid_status_filter: "Statut invalide utilisé dans le filtrage. Veuillez survoler l'en-tête du statut pour voir les statuts valides.",
    photos_must_be_between_one_and_ten: "Les photos doivent être comprises entre 1 et 10.",
    signatures_must_be_between_one_and_five: "Les signatures doivent être comprises entre 1 et 5.",
    signature_settings: "Paramètres de signature",
    photo_settings: "Paramètres de photo",
    disable_gallery: "Désactiver la galerie",
    photo_setting_tool_tip: "Autoriser 1 à 10 photos. Nouvelle photo requise.",
    signature_setting_tool_tip: "Autoriser 1 à 5 signatures.",
};
